// ========== Price Calculation ==========
const finalPrice = (element, qty) => {
    if (element.dataset.productId === '16470596976985') {
        const variants = JSON.parse(element.querySelector('[data-wunschfarbe-variants]').textContent);
        const chosen = [...element.querySelectorAll('variant-selects input[type="radio"]:checked')].map(input => input.value);
        const variant = variants.find(item => item.options.every((value, index) => value === chosen[index]));
        const amount = Number(qty || element.querySelector('quantity-input input')?.value || 1);
        return variant ? (variant.price * amount / 100).toFixed(2) : '–';
    }
    const activePrice = element.querySelector('input[type="radio"]:checked');
    const label = element.querySelector(`label[for="${activePrice.id}"]`);
    const price = label
        .querySelector('.variant-option-price')
        .textContent
        .trim()
        .replace(/\D/g, '');
    let quantity;
    if (qty) {
        quantity = qty;
    } else {
        quantity = element.querySelector('quantity-input input').value;
    }
    const priceNumber = Number(price) * Number(quantity);
    return (priceNumber / 100).toFixed(2);
};

const insertFinalPrice = (element, qty) => {
    const container = element.querySelector('.choose-color__price--final-value');
    const currency = element.dataset.currency;
    container.textContent = finalPrice(element, qty) + currency;
};

// ========== RAL Color Database ==========
const RAL_CLASSIC_COLORS = {
    '1000': '#BEBD7F', '1001': '#C2B078', '1002': '#C6A664', '1003': '#E5BE01',
    '1004': '#CDA434', '1005': '#A98307', '1006': '#E4A010', '1007': '#DC9D00',
    '1011': '#8A6642', '1012': '#C7B446', '1013': '#EAE6CA', '1014': '#E1CC4F',
    '1015': '#E6D690', '1016': '#EDFF21', '1017': '#F5D033', '1018': '#F8F32B',
    '1019': '#9E9764', '1020': '#999950', '1021': '#F3DA0B', '1023': '#FAD201',
    '1024': '#AEA04B', '1026': '#FFFF00', '1027': '#9D9101', '1028': '#F4A900', '1032': '#D6AE01',
    '1033': '#F3A505', '1034': '#EFA94A', '1037': '#F39F18', '2000': '#ED760E',
    '2001': '#C93C20', '2002': '#CB2821', '2003': '#FF7514', '2004': '#F44611',
    '2005': '#FF2301', '2007': '#FFA420', '2008': '#F75E25', '2009': '#F54021',
    '2010': '#D84B20', '2011': '#EC7C26', '2012': '#E55137', '2013': '#C35831',
    '2017': '#FA4402', '3000': '#AF2B1E', '3001': '#A52019',
    '3002': '#A2231D', '3003': '#9B111E', '3004': '#75151E', '3005': '#5E2129',
    '3007': '#412227', '3009': '#642424', '3011': '#781F19', '3012': '#C1876B',
    '3013': '#A12312', '3014': '#D36E70', '3015': '#EA899A', '3016': '#B32821',
    '3017': '#E63244', '3018': '#D53032', '3020': '#CC0605', '3022': '#D95030',
    '3024': '#F80000', '3026': '#FE0000', '3027': '#C51D34', '3028': '#CB3234',
    '3031': '#B32428', '3032': '#721422', '3033': '#B44C43',
    '4001': '#6D3F5B', '4002': '#922B3E', '4003': '#DE4C8A', '4004': '#641C34',
    '4005': '#6C4675', '4006': '#A03472', '4007': '#4A192C', '4008': '#924E7D',
    '4009': '#A18594', '4010': '#CF3476', '4011': '#8673A1', '4012': '#6C6874',
    '5000': '#354D73', '5001': '#1F3438', '5002': '#20214F', '5003': '#1D1E33',
    '5004': '#18171C', '5005': '#1E2460', '5007': '#3E5F8A', '5008': '#26252D',
    '5009': '#025669', '5010': '#0E294B', '5011': '#231A24', '5012': '#3B83BD',
    '5013': '#1E213D', '5014': '#606E8C', '5015': '#2271B3', '5017': '#063971',
    '5018': '#3F888F', '5019': '#1B5583', '5020': '#1D334A', '5021': '#256D7B',
    '5022': '#252850', '5023': '#49678D', '5024': '#5D9B9B', '5025': '#2A6478',
    '5026': '#102C54', '6000': '#316650', '6001': '#287233', '6002': '#2D572C',
    '6003': '#424632', '6004': '#1F3A3D', '6005': '#2F4538', '6006': '#3E3B32',
    '6007': '#343B29', '6008': '#39352A', '6009': '#31372B', '6010': '#35682D',
    '6011': '#587246', '6012': '#343E40', '6013': '#6C7156', '6014': '#47402E',
    '6015': '#3B3C36', '6016': '#1E5945', '6017': '#4C9141', '6018': '#57A639',
    '6019': '#BDECB6', '6020': '#2E3A23', '6021': '#89AC76', '6022': '#25221B',
    '6024': '#308446', '6025': '#3D642D', '6026': '#015D52', '6027': '#84C3BE',
    '6028': '#2C5545', '6029': '#20603D', '6032': '#317F43', '6033': '#497E76',
    '6034': '#7FB5B5', '6035': '#1C542D', '6036': '#193737', '6037': '#008F39',
    '6038': '#00BB2D', '6039': '#ABC251', '7000': '#78858B', '7001': '#8A9597',
    '7002': '#7E7B52',
    '7003': '#6C7059', '7004': '#969992', '7005': '#646B63', '7006': '#6D6552',
    '7008': '#6A5F31', '7009': '#4D5645', '7010': '#4C514A', '7011': '#434B4D',
    '7012': '#4E5754', '7013': '#464531', '7015': '#434750', '7016': '#293133',
    '7021': '#23282B', '7022': '#332F2C', '7023': '#686C5E', '7024': '#474A51',
    '7026': '#2F353B', '7030': '#8B8C7A', '7031': '#474B4E', '7032': '#B8B799',
    '7033': '#7D8471', '7034': '#8F8B66', '7035': '#D7D7D7', '7036': '#7F7679',
    '7037': '#7D7F7D', '7038': '#B5B8B1', '7039': '#6C6960', '7040': '#9DA1AA',
    '7042': '#8D948D', '7043': '#4E5452', '7044': '#CAC4B0', '7045': '#909090',
    '7046': '#82898F', '7047': '#D0D0D0', '7048': '#898176', '8000': '#826C34',
    '8001': '#955F20', '8002': '#6C3B2A', '8003': '#734222', '8004': '#8E402A',
    '8007': '#59351F', '8008': '#6F4F28', '8011': '#5B3A29', '8012': '#592321',
    '8014': '#382C1E', '8015': '#633A34', '8016': '#4C2F27', '8017': '#45322E',
    '8019': '#403A3A', '8022': '#212121', '8023': '#A65E2E', '8024': '#79553D',
    '8025': '#755C48', '8028': '#4E3B31', '8029': '#763C28', '9001': '#FDF4E3',
    '9002': '#E7EBDA', '9003': '#F4F4F4', '9004': '#282828', '9005': '#0A0A0A',
    '9006': '#A5A5A5', '9007': '#8F8F8F', '9010': '#FFFFFF', '9011': '#1C1C1C',
    '9012': '#F8F2E1', '9016': '#F6F6F6', '9017': '#1E1E1E', '9018': '#D7D7D7', '9022': '#9C9C9C',
    '9023': '#828282'
};

/*
 * Full RAL colour data is kept compact so the existing picker can match
 * a visual selection to a real RAL CLASSIC or RAL DESIGN colour
 * code without rendering thousands of individual buttons.
 */
const RAL_ALL_COLOR_SOURCE = '000 15 00|#252626;000 20 00|#2E2F2F;000 25 00|#3B3C3D;000 30 00|#444545;000 35 00|#505151;000 40 00|#5C5C5C;000 45 00|#696969;000 50 00|#737575;000 55 00|#808081;000 60 00|#8C8D8D;000 65 00|#9C9C9D;000 70 00|#A9AAAA;000 75 00|#B7B8B8;000 80 00|#C6C6C5;000 85 00|#D3D4D2;000 90 00|#E0E1DF;010 20 10|#3C2D2F;010 20 15|#3F272C;010 20 20|#44242B;010 20 25|#48202B;010 30 10|#544244;010 30 15|#573E43;010 30 20|#5D3B42;010 30 25|#633640;010 30 30|#68323F;010 30 35|#6A2B3B;010 30 40|#732139;010 30 44|#79143B;010 40 10|#6A595B;010 40 15|#705458;010 40 20|#765258;010 40 25|#7C4E57;010 40 30|#824955;010 40 35|#854452;010 40 40|#8B3D51;010 40 45|#933851;010 40 50|#98304F;010 40 53|#9B274D;010 50 10|#827074;010 50 15|#886C71;010 50 20|#8D686F;010 50 25|#95646E;010 50 30|#9D5F6C;010 50 35|#A15A6A;010 50 40|#A6576A;010 50 45|#AB5168;010 50 50|#B54867;010 60 10|#9C898C;010 60 15|#A4868B;010 60 20|#AB8289;010 60 25|#B27C88;010 60 30|#B87886;010 60 35|#C07384;010 60 40|#C66E82;010 60 45|#CE6980;010 70 10|#B9A4A7;010 70 15|#BFA0A5;010 70 20|#C89CA4;010 70 25|#CF97A2;010 70 30|#D594A0;010 70 35|#DD8E9D;010 80 10|#D5BEC0;010 80 15|#DCBABF;010 80 20|#E5B7BE;010 85 05|#D8CECF;010 85 10|#DECACE;010 85 15|#E7C8CE;010 85 20|#EEC7CE;010 90 05|#EBDEDC;010 90 10|#EDD8D6;010 93 05|#EDE3E5;020 20 05|#352E2E;020 20 10|#3B2A2B;020 20 20|#452629;020 20 29|#4F1A23;020 30 05|#4B4343;020 30 10|#51403F;020 30 20|#5D3A3B;020 30 30|#653035;020 30 40|#722432;020 30 48|#7A0B2D;020 40 05|#645B5B;020 40 10|#685757;020 40 20|#745152;020 40 30|#7F494C;020 40 40|#893E47;020 40 50|#932E40;020 50 05|#7C7372;020 50 10|#816F6F;020 50 20|#8E6969;020 50 30|#9A6163;020 50 40|#A4565E;020 50 50|#B14B59;020 50 58|#BF4355;020 60 05|#948B8B;020 60 10|#9B8888;020 60 20|#A88283;020 60 30|#B5797C;020 60 40|#C27078;020 70 05|#B0A6A6;020 70 10|#B5A2A2;020 70 20|#C79D9F;020 70 30|#D59598;020 80 05|#CEC3C2;020 80 10|#D3BDBD;020 80 20|#E3B7BA;020 85 05|#DACFCE;020 85 10|#E0CACA;020 85 20|#F1C7C6;020 90 05|#ECE1DC;020 90 10|#EDDBD7;020 93 05|#F1E4E1;030 30 10|#514340;030 30 20|#5B3C38;030 30 30|#653430;030 30 40|#722B2C;030 30 45|#742529;030 40 10|#665855;030 40 20|#75544F;030 40 30|#804D48;030 40 40|#8A433F;030 40 50|#963838;030 40 60|#9F2833;030 50 10|#816F6C;030 50 20|#8C6A64;030 50 30|#99635C;030 50 40|#A65C55;030 50 50|#B0524E;030 50 60|#BC4444;030 60 10|#9A8986;030 60 20|#A8837E;030 60 30|#B77674;030 60 40|#C1756E;030 60 50|#CD6B65;030 70 10|#B6A3A0;030 70 20|#C59B95;030 70 30|#D3958D;030 70 40|#E08D85;030 80 10|#D3BDBA;030 80 20|#E3B6B2;030 85 05|#D9CCC7;030 85 10|#DECAC5;030 85 20|#ECC9BF;030 90 05|#EADEDA;030 90 10|#F0DDD6;030 93 05|#F4E8E4;040 20 19|#442B21;040 30 05|#4B4441;040 30 10|#4E413A;040 30 20|#593D32;040 30 30|#633729;040 30 40|#6D3425;040 40 05|#635B58;040 40 10|#675952;040 40 20|#72554A;040 40 30|#7B4E3E;040 40 40|#854532;040 40 50|#8F412A;040 40 60|#96341E;040 40 67|#A03326;040 50 05|#7B7370;040 50 10|#80716A;040 50 20|#8C6C60;040 50 30|#986655;040 50 40|#A1604B;040 50 50|#AD5840;040 50 60|#BB5237;040 50 70|#BF4A30;040 60 05|#958C89;040 60 10|#9B8A82;040 60 20|#A58376;040 60 30|#B3806D;040 60 40|#BC7961;040 60 50|#CA7357;040 60 60|#D26C4D;040 70 05|#AFA6A3;040 70 10|#B7A49C;040 70 20|#C59F91;040 70 30|#D19986;040 70 40|#D7957C;040 70 50|#E78D6F;040 80 05|#CDC3BF;040 80 10|#D5C2B9;040 80 20|#E5BEAF;040 80 30|#F0B8A3;040 85 05|#DCD0CB;040 85 10|#E3CFC5;040 85 20|#F0CAB9;040 90 05|#ECE0D9;040 90 10|#F1DFD3;040 93 05|#F2E8E1;050 20 10|#3A3028;050 20 16|#3F2D21;050 30 10|#4C4137;050 30 20|#573F2D;050 30 30|#613C26;050 30 36|#663B20;050 40 10|#675A50;050 40 20|#6E5644;050 40 30|#775239;050 40 40|#7F4D2A;050 40 50|#8A4924;050 50 10|#7F7469;050 50 20|#89705C;050 50 30|#936B4F;050 50 40|#9C6543;050 50 50|#A66136;050 50 60|#AA5A2A;050 50 70|#B7510E;050 50 78|#BE5B1C;050 60 10|#988B7F;050 60 20|#A28671;050 60 30|#B18466;050 60 40|#B77F59;050 60 50|#C37C4D;050 60 60|#CD763E;050 60 70|#D16C31;050 60 80|#DC6621;050 70 10|#B5A79C;050 70 20|#C0A48E;050 70 30|#CB9F80;050 70 40|#D79A73;050 70 50|#DF9566;050 70 60|#E98F57;050 80 10|#D2C3B6;050 80 20|#DDBEA6;050 80 30|#E8B999;050 85 05|#DDD1C9;050 85 10|#DDCDBF;050 85 20|#EBCBB2;050 90 05|#E9DED5;050 90 10|#F4E1D3;050 93 05|#F3EAE2;060 20 05|#35322F;060 30 05|#4A453F;060 30 10|#4D4338;060 30 20|#54422D;060 30 27|#5B4125;060 40 05|#615D56;060 40 10|#655A4E;060 40 20|#6E5A42;060 40 30|#755735;060 40 40|#7F562B;060 50 05|#7A756D;060 50 10|#7E7466;060 50 20|#877259;060 50 30|#92704D;060 50 40|#986C3D;060 50 50|#A06932;060 50 60|#A36217;060 50 70|#AC630F;060 60 05|#959088;060 60 10|#9A8E80;060 60 20|#A48B71;060 60 30|#AC8A64;060 60 40|#B88B55;060 60 50|#B98044;060 60 60|#C27E32;060 60 70|#C87A1E;060 60 80|#D27610;060 70 05|#B0AAA2;060 70 10|#B5A99A;060 70 20|#BDA68A;060 70 30|#C4A079;060 70 40|#D1A16F;060 70 50|#D89D5F;060 70 60|#DD974C;060 70 70|#E79539;060 80 05|#CCC6BC;060 80 10|#D0C3B4;060 80 20|#DBC2A5;060 80 30|#E7BF93;060 80 40|#EDBA82;060 85 05|#DBD3C9;060 85 10|#E1D3C1;060 85 20|#E9CFB2;060 85 30|#F4CDA1;060 90 05|#EBE2D7;060 90 10|#F0E0CF;060 90 15|#F4DDC6;060 93 05|#F3EBE2;070 30 10|#4A4437;070 30 20|#53452E;070 40 10|#625C4D;070 40 20|#695A3E;070 40 30|#705A33;070 40 40|#755823;070 50 10|#7A7465;070 50 20|#837356;070 50 30|#887145;070 50 40|#8F6F34;070 50 50|#907031;070 50 55|#98712B;070 60 10|#948C7C;070 60 20|#9C8D6F;070 60 30|#A3895E;070 60 40|#AA894C;070 60 50|#B0893B;070 60 60|#B6862A;070 60 70|#BC8318;070 60 75|#BD8209;070 70 10|#AFA897;070 70 20|#B9A787;070 70 30|#C2A877;070 70 40|#C9A565;070 70 50|#CEA456;070 70 60|#D9A344;070 70 70|#D99D2C;070 70 80|#DC9914;070 80 10|#CEC5B2;070 80 20|#D9C6A2;070 80 30|#E1C392;070 80 40|#E9C383;070 80 50|#F0C170;070 80 60|#F8BF5D;070 85 05|#D8D2C6;070 85 10|#DED3BF;070 85 20|#E7D1AB;070 85 30|#EFD29E;070 90 05|#ECE4D9;070 90 10|#EEE3D0;070 90 20|#F7E2BE;070 93 05|#F3EDE2;075 40 10|#625D4F;075 40 20|#675B40;075 40 30|#6B5930;075 40 38|#705A23;075 50 10|#7B7566;075 50 20|#827456;075 50 30|#897547;075 50 40|#8D7337;075 50 50|#917224;075 50 58|#926F04;075 60 10|#97907F;075 60 20|#9D8E6E;075 60 30|#A38E5F;075 60 40|#A98E50;075 60 50|#AC8C3C;075 60 60|#B28925;075 60 70|#B68804;075 70 10|#B1AB99;075 70 20|#B9A985;075 70 30|#BFA976;075 70 40|#C5A764;075 70 50|#CBA655;075 70 60|#D1A43F;075 70 70|#D7A427;075 70 80|#D6A209;075 80 10|#D0C6B3;075 80 20|#D7C6A2;075 80 30|#DCC58F;075 80 40|#E3C380;075 80 50|#E8C06D;075 80 60|#EFBF5D;075 85 10|#DFD5C0;075 85 20|#E6D4AE;075 85 30|#EDD39E;075 85 40|#F3D28D;075 90 10|#F1E6CF;075 90 20|#F5E2BD;075 93 05|#F2EEE2;080 20 05|#33312B;080 20 10|#353122;080 30 05|#49453E;080 30 10|#494435;080 30 20|#4F4428;080 30 26|#52441F;080 40 05|#615D56;080 40 10|#635E4E;080 40 20|#665B3C;080 40 30|#6B5B2F;080 40 40|#715C1B;080 50 05|#78756D;080 50 10|#7B7666;080 50 20|#817656;080 50 30|#847545;080 50 40|#887436;080 50 50|#8D7524;080 60 05|#928F87;080 60 10|#948E7C;080 60 20|#9B8F6C;080 60 30|#A08E5B;080 60 40|#A38E4F;080 60 50|#A88E3C;080 60 60|#AD8E23;080 60 70|#AF8D08;080 70 05|#AEAAA1;080 70 10|#B0AA97;080 70 20|#B6AA86;080 70 30|#BBA976;080 70 40|#C2AA64;080 70 50|#C6A953;080 70 60|#CBAA40;080 70 70|#CFAA2C;080 70 80|#D1A706;080 70 88|#D2A600;080 80 05|#CBC6BC;080 80 10|#CFC7B3;080 80 20|#D4C69F;080 80 30|#D9C58E;080 80 40|#E0C57D;080 80 50|#E5C56C;080 80 60|#EAC557;080 80 70|#ECC345;080 80 80|#F1C12B;080 80 90|#F4C208;080 85 05|#D8D2C6;080 85 10|#DBD2BE;080 85 20|#E3D4AF;080 85 30|#E8D39D;080 85 40|#EFD38A;080 90 05|#ECE6D9;080 90 10|#ECE3CD;080 90 20|#F1E1BB;080 90 30|#F8E3AB;080 93 05|#F1EBDF;085 40 10|#626050;085 40 20|#645E3E;085 40 30|#6A6034;085 50 10|#7A7764;085 50 20|#7F7756;085 50 30|#837847;085 50 40|#847636;085 50 50|#887725;085 60 10|#94907F;085 60 20|#9A906E;085 60 30|#9E905E;085 60 40|#A1914E;085 60 50|#A5923B;085 60 60|#A89224;085 70 10|#ADAA96;085 70 20|#B5AA87;085 70 30|#B9AB74;085 70 40|#BCAA65;085 70 50|#C1AB51;085 70 60|#C2AB3D;085 70 70|#C6A931;085 70 75|#CAAB1F;085 80 10|#CBC6B1;085 80 20|#D1C7A1;085 80 30|#D8C88E;085 80 40|#DBC87D;085 80 50|#DEC76B;085 80 60|#E1C658;085 80 70|#E5C645;085 80 80|#E6C52E;085 80 85|#E6C526;085 85 10|#D9D2BC;085 85 20|#DFD3AB;085 85 30|#E5D39A;085 85 40|#EBD58B;085 90 10|#EEE7D1;085 90 20|#F1E4BB;085 90 30|#F4E2A9;085 93 05|#F1EEE2;090 30 10|#4A4738;090 30 20|#4D4829;090 40 10|#635F51;090 40 20|#655E3F;090 40 30|#696033;090 50 10|#797667;090 50 20|#7D7657;090 50 30|#827846;090 50 40|#837838;090 60 10|#928E7F;090 60 20|#988F6D;090 60 30|#9B9060;090 60 40|#9D904E;090 60 50|#9C8F3A;090 60 60|#A2942C;090 70 10|#AEAA98;090 70 20|#B2AA85;090 70 30|#B5A976;090 70 40|#BBAD65;090 70 50|#BDAD55;090 70 60|#BEAE41;090 70 70|#C0AF29;090 70 80|#C0AE10;090 80 10|#CBC5B0;090 80 20|#CEC4A0;090 80 30|#D5C892;090 80 40|#D8CA82;090 80 50|#DCCA6B;090 80 60|#DCC956;090 80 70|#E0CC49;090 80 80|#DECA28;090 80 90|#E3CD07;090 85 05|#D6D2C7;090 85 10|#D9D3BF;090 85 20|#DED5AD;090 85 30|#E2D69C;090 85 40|#E5D68A;090 85 50|#E9D879;090 90 05|#E7E3D8;090 90 10|#E9E4D0;090 90 20|#EFE5BC;090 90 30|#F1E5AB;090 90 40|#F5E698;090 90 50|#F5E485;090 90 60|#F6E371;090 93 05|#EEEBE0;095 40 10|#615E50;095 40 20|#635D3F;095 40 30|#635F31;095 50 10|#787466;095 50 20|#7C7759;095 50 30|#7E7848;095 50 40|#807A37;095 50 50|#7F7E24;095 60 10|#938F7F;095 60 20|#95906F;095 60 30|#98915D;095 60 40|#99924E;095 60 50|#9A953D;095 60 60|#969329;095 60 70|#979803;095 70 10|#AEAA99;095 70 20|#B2AC8A;095 70 30|#B4AD79;095 70 40|#B5AE65;095 70 50|#B5AC58;095 70 60|#B6AC47;095 70 70|#B7B12E;095 80 10|#CAC6B4;095 80 20|#CFC7A4;095 80 30|#D4CA93;095 80 40|#D5CC80;095 80 50|#D6CA71;095 80 60|#D3C85E;095 80 70|#D3CC4A;095 80 80|#CFC735;095 85 10|#D9D5C2;095 85 20|#DDD7B3;095 85 30|#E0D89F;095 85 40|#E3DA8D;095 85 50|#E4D97D;095 90 10|#E9E4CF;095 90 20|#ECE4BE;095 90 30|#EEE7A9;095 90 40|#F0E696;095 90 50|#F6E988;095 90 59|#F6E979;095 93 05|#ECEBE1;100 20 05|#32332D;100 30 05|#44443D;100 30 10|#464536;100 30 20|#4A4B2A;100 40 05|#5C5C54;100 40 10|#5F5E4F;100 40 20|#605F41;100 40 30|#616130;100 40 40|#5E641D;100 50 05|#75756D;100 50 10|#777564;100 50 20|#797957;100 50 30|#797848;100 50 40|#797B36;100 50 50|#767E23;100 60 05|#908F87;100 60 10|#8E8D7D;100 60 20|#93926F;100 60 30|#93925E;100 60 40|#959351;100 60 50|#969640;100 60 60|#8D9622;100 70 05|#ACABA2;100 70 10|#ADAB98;100 70 20|#ADAD87;100 70 30|#AEAD77;100 70 40|#B2B069;100 70 50|#B0AE58;100 70 60|#AFB046;100 80 05|#C5C5BB;100 80 10|#C8C6B1;100 80 20|#CDCBA3;100 80 30|#CCCA91;100 80 40|#CECB80;100 80 50|#CDCB70;100 80 60|#CED15B;100 80 70|#CFD24B;100 80 80|#CBD334;100 85 05|#D6D5CA;100 85 10|#D7D5C0;100 85 20|#DAD8B0;100 85 30|#DCD89F;100 90 05|#E5E4D7;100 90 10|#E7E4CF;100 90 20|#EAE6BD;100 90 30|#EAE6A9;100 90 40|#EDE999;100 90 50|#ECE888;100 93 05|#EDEDE1;1000|#C5BB8A;1001|#C6B286;1002|#C7AE72;1003|#E6B019;1004|#D2A40E;1005|#BC9611;1006|#CF9804;1007|#D49300;1011|#A38454;1012|#CFB539;1013|#DFDBC7;1014|#D4C79C;1015|#DED3B6;1016|#E8E253;1017|#E4AF56;1018|#EBD346;1019|#9C917B;1020|#999167;1021|#E5C000;1023|#E6BE05;1024|#AD9451;1026|#FFFF00;1027|#998420;1028|#F2A500;1032|#CFA81E;1033|#E4A02D;1034|#D9A156;1035|#898271;1036|#746341;1037|#DB9A17;110 20 10|#303324;110 30 10|#46483A;110 30 20|#454B2E;110 40 10|#5D5F50;110 40 20|#5A5F3F;110 40 30|#5B6434;110 40 40|#596828;110 50 10|#747666;110 50 20|#747858;110 50 30|#747B4C;110 50 40|#717D3A;110 50 50|#6B8024;110 50 55|#6B841A;110 60 10|#8D907F;110 60 20|#8B9170;110 60 30|#8E9665;110 60 40|#8B9654;110 60 50|#879A42;110 60 60|#859F2F;110 60 65|#85A11F;110 70 10|#A9AC99;110 70 20|#A8AD89;110 70 30|#A6AD7A;110 70 40|#A6B16C;110 70 50|#A7B55E;110 70 60|#A0B749;110 70 70|#97B821;110 70 77|#97B720;110 80 10|#C2C5B3;110 80 20|#C3CCA2;110 80 30|#C5CC93;110 80 40|#C3CF85;110 80 50|#C3D274;110 80 60|#BED561;110 80 70|#BDD651;110 85 10|#D2D5C1;110 85 20|#D0D8AF;110 85 30|#D2DAA0;110 85 40|#CEDA8B;110 85 50|#CFDC7C;110 90 05|#E2E2D7;110 90 10|#E3E6D0;110 90 20|#E1E8BD;110 90 30|#E2E9AB;110 90 40|#E1EB9D;110 93 05|#EAEBE0;110 96 02|#F3F4EF;120 30 05|#42443D;120 30 10|#424739;120 30 20|#404A2E;120 40 05|#5A5C55;120 40 10|#595E4F;120 40 20|#576044;120 40 30|#546438;120 40 40|#4E6923;120 50 05|#73756D;120 50 10|#717767;120 50 20|#707A5A;120 50 30|#6C7C4C;120 50 40|#67823F;120 50 50|#638131;120 60 05|#8F9289;120 60 10|#8B9081;120 60 20|#889372;120 60 30|#879866;120 60 40|#839A58;120 60 50|#7F9D4A;120 60 60|#789E39;120 60 63|#75A133;120 70 05|#A8ABA1;120 70 10|#A6AB99;120 70 20|#A3AE8C;120 70 30|#A1B37F;120 70 40|#9DB771;120 70 50|#99B861;120 70 60|#92B651;120 70 70|#90BC44;120 70 75|#8AB936;120 80 05|#C3C6BD;120 80 10|#C1C7B3;120 80 20|#BFCBA7;120 80 30|#BBCE96;120 80 40|#B8D288;120 80 50|#B3D579;120 80 60|#B0D86C;120 85 05|#D1D4CA;120 85 10|#CED6C2;120 85 20|#CDD9B3;120 85 30|#CBDEA3;120 90 05|#DFE2D7;120 90 10|#E2E7D2;120 90 20|#DCE8C1;120 90 30|#D9ECB1;120 93 05|#E9ECE0;130 30 10|#41483B;130 30 20|#3C4A30;130 40 10|#5A6053;130 40 20|#526145;130 40 30|#4F643B;130 50 10|#6E7768;130 50 20|#6B7C5E;130 50 30|#657E51;130 50 40|#5F8146;130 50 50|#58823B;130 60 10|#899283;130 60 20|#849477;130 60 30|#7E976B;130 60 40|#789A5E;130 60 50|#719D50;130 60 60|#69A044;130 70 10|#A4AE9E;130 70 20|#A0B191;130 70 30|#98B484;130 70 40|#93B676;130 70 50|#8DBA6C;130 70 60|#85BD5D;130 80 10|#C0C8B7;130 80 20|#BACCAB;130 80 30|#B5D09E;130 80 40|#AFD492;130 80 50|#A9D684;130 85 05|#CFD5CB;130 85 10|#CDD7C4;130 85 20|#C7DAB8;130 85 30|#C4DEAC;130 90 05|#DDE2D8;130 90 10|#DEE8D4;130 90 20|#D6E9C5;130 93 05|#E7ECE2;140 20 05|#2D322D;140 20 10|#2B3528;140 20 20|#2A3927;140 30 05|#444944;140 30 10|#404B3D;140 30 20|#3B4E36;140 30 30|#32532A;140 30 40|#2B532A;140 40 05|#5A5F59;140 40 10|#556053;140 40 20|#4C6248;140 40 30|#47663F;140 40 40|#406B37;140 40 50|#3B6F31;140 50 05|#70766F;140 50 10|#6D786B;140 50 20|#667B60;140 50 30|#608056;140 50 40|#55824B;140 50 50|#4F8744;140 50 60|#458938;140 60 05|#898F89;140 60 10|#849183;140 60 20|#80987B;140 60 30|#789B6F;140 60 40|#729E65;140 60 50|#67A05A;140 60 60|#5FA251;140 60 70|#57A549;140 70 05|#A4AAA3;140 70 10|#9EAC9E;140 70 20|#98B194;140 70 30|#90B589;140 70 40|#8BB97F;140 70 50|#7FBA71;140 70 60|#7ABF68;140 80 05|#C2C7BF;140 80 10|#BCC9B9;140 80 20|#B4CDAD;140 80 30|#ACD1A3;140 80 40|#A1D597;140 85 05|#CED6CD;140 85 10|#CAD8C8;140 85 20|#C2DCBB;140 85 30|#B9E0B1;140 90 05|#DFE5DA;140 90 10|#DAE7D4;140 93 05|#E7EEE4;150 30 10|#404C42;150 30 20|#374F3C;150 30 30|#2D5034;150 40 10|#546156;150 40 20|#4D6550;150 40 30|#416747;150 40 40|#366A3F;150 40 50|#2D6B3B;150 50 10|#6A786C;150 50 20|#627D66;150 50 30|#5A825F;150 50 40|#52855C;150 50 50|#458752;150 50 60|#3C8A4D;150 60 10|#869489;150 60 20|#7C9881;150 60 30|#729A78;150 60 40|#689E6F;150 60 50|#60A36C;150 60 60|#4FA25E;150 70 10|#9EADA1;150 70 20|#96B39B;150 70 30|#8CB892;150 70 40|#82BA8A;150 70 50|#77BD80;150 80 10|#BBCABD;150 80 20|#B1CFB5;150 80 30|#A6D3AE;150 80 40|#9DD8A5;150 85 05|#CCD5CD;150 85 10|#C8D8C9;150 85 20|#BFDDC0;150 90 05|#DBE3D9;150 90 10|#D8E8D7;150 93 05|#E4EDE3;160 20 05|#2F3532;160 20 10|#29362F;160 20 15|#22372A;160 20 20|#1F3429;160 30 05|#414844;160 30 10|#3D4A42;160 30 15|#374A3F;160 30 20|#304C3C;160 30 25|#2D4E3A;160 30 30|#275038;160 30 35|#1E5035;160 30 40|#195235;160 40 05|#58605B;160 40 10|#516159;160 40 15|#4C6356;160 40 20|#466353;160 40 25|#416450;160 40 30|#3C674E;160 40 35|#36694C;160 40 40|#326B4C;160 40 45|#296846;160 40 50|#1D6A43;160 40 55|#1B6D43;160 50 05|#6F7772;160 50 10|#687870;160 50 15|#647C6E;160 50 20|#5E7E6C;160 50 25|#587E68;160 50 30|#538166;160 50 35|#4F8364;160 50 40|#468362;160 50 45|#438661;160 50 50|#3A865D;160 50 55|#35885C;160 50 60|#2A8758;160 60 05|#88908B;160 60 10|#819289;160 60 15|#7C9687;160 60 20|#769784;160 60 25|#719A80;160 60 30|#6B9B7F;160 60 35|#669E7D;160 60 40|#5F9D7A;160 60 45|#5AA178;160 60 50|#51A075;160 60 55|#4C9F70;160 60 58|#45A26F;160 70 05|#A2ABA6;160 70 10|#9BAEA3;160 70 15|#94B09F;160 70 20|#90B29D;160 70 25|#8BB69C;160 70 30|#84B79A;160 70 35|#7DB897;160 70 40|#78BB94;160 70 45|#71BD91;160 70 50|#6BBE91;160 80 05|#BDC6C0;160 80 10|#B6C9BE;160 80 15|#AFCCBB;160 80 20|#A9CEB8;160 80 25|#A5D0B7;160 80 30|#A1D4B5;160 85 05|#C9D3CC;160 85 10|#C2D6C9;160 85 15|#BEDAC7;160 90 05|#DAE3DB;160 90 10|#D3E7D8;160 90 15|#CDE9D5;160 93 05|#E0EBE6;170 20 10|#25342F;170 20 15|#21362E;170 20 20|#1A372E;170 20 25|#153C2E;170 30 10|#3B4B44;170 30 15|#334C42;170 30 20|#2E4B41;170 30 25|#264F41;170 30 30|#224F40;170 30 35|#175141;170 30 40|#0D5240;170 40 10|#4F6059;170 40 15|#496158;170 40 20|#436458;170 40 25|#3E6556;170 40 30|#396957;170 40 35|#2F6854;170 40 40|#256954;170 40 45|#1C6A54;170 40 50|#176950;170 50 10|#677973;170 50 15|#617D71;170 50 20|#5B7D70;170 50 25|#547F6E;170 50 30|#4C816E;170 50 35|#46816D;170 50 40|#3C846A;170 50 45|#37846B;170 50 50|#2A8769;170 50 55|#208568;170 60 10|#7F928B;170 60 15|#7A958A;170 60 20|#719889;170 60 25|#6C9889;170 60 30|#649A87;170 60 35|#5D9E87;170 60 40|#569E85;170 60 45|#4E9E83;170 60 50|#47A185;170 70 10|#9AAEA6;170 70 15|#93B0A4;170 70 20|#8CB4A4;170 70 25|#87B6A2;170 70 30|#7EB8A3;170 70 35|#77B89F;170 70 40|#70B99E;170 80 10|#B6CAC2;170 80 15|#ADCDC1;170 80 20|#A8D2C0;170 80 25|#9FD1BE;170 85 05|#C9D5D0;170 85 10|#C3D9CF;170 85 15|#BBDBCC;170 85 20|#B4DDCB;170 90 05|#D9E3DD;170 90 10|#D1E7DC;170 93 05|#E2ECE7;180 20 05|#2D3634;180 20 10|#253532;180 20 15|#1D3532;180 20 20|#123633;180 30 05|#424A49;180 30 10|#394A46;180 30 15|#334C47;180 30 20|#2C4D47;180 30 25|#254F48;180 30 30|#1A4F48;180 30 35|#135049;180 40 05|#565F5D;180 40 10|#4E615D;180 40 15|#47635D;180 40 20|#40655E;180 40 25|#39665E;180 40 30|#2E675F;180 40 35|#25665D;180 40 40|#1C665D;180 40 45|#0E675E;180 50 05|#6F7877;180 50 10|#657975;180 50 15|#5D7B75;180 50 20|#567D75;180 50 25|#4E7E76;180 50 30|#468176;180 50 35|#3E8276;180 50 40|#358175;180 50 45|#2B8377;180 50 50|#0E8376;180 60 05|#86908F;180 60 10|#7D928E;180 60 15|#76958F;180 60 20|#6E978F;180 60 25|#65988E;180 60 30|#5E9B8F;180 60 35|#579D90;180 60 40|#4D9E91;180 60 45|#439F91;180 60 50|#359F91;180 70 05|#A1ABA9;180 70 10|#96ADA8;180 70 15|#8FB0A9;180 70 20|#88B3AA;180 70 25|#7FB4A9;180 70 30|#79B7AA;180 70 35|#6EB8AA;180 70 40|#67BBAC;180 80 05|#BDC6C3;180 80 10|#B4CAC4;180 80 15|#ADCEC5;180 80 20|#A2CFC4;180 80 25|#9BD1C5;180 80 30|#97D6C8;180 85 05|#C8D4D1;180 85 10|#C1D8D1;180 85 15|#BBDCD2;180 85 20|#B0DDCF;180 90 05|#DAE5E1;180 90 10|#D2EAE2;180 93 05|#E2EEEA;190 20 20|#163838;190 30 15|#334C4B;190 30 20|#2A4D4D;190 30 25|#224E4F;190 30 30|#174F51;190 30 35|#0F4F52;190 40 10|#4F6060;190 40 15|#476263;190 40 20|#3F6464;190 40 25|#366566;190 40 30|#2D6667;190 40 35|#1B6769;190 40 40|#10676A;190 40 45|#0C6A6D;190 50 10|#667979;190 50 15|#5E7B7A;190 50 20|#567C7B;190 50 25|#4D7E7D;190 50 30|#437F7F;190 50 35|#3B8081;190 50 40|#308184;190 50 45|#1B8386;190 60 10|#7E9392;190 60 15|#779493;190 60 20|#719796;190 60 25|#679998;190 60 30|#5E9A9A;190 60 35|#549B9C;190 60 40|#489C9E;190 60 45|#3C9B9D;190 70 10|#98ADAC;190 70 15|#90AFAD;190 70 20|#87B0AF;190 70 25|#7FB3B2;190 70 30|#79B6B6;190 70 35|#6DB5B5;190 80 10|#B3C9C6;190 80 15|#ACCCCA;190 80 20|#A2CDCB;190 80 25|#9ACFCD;190 85 05|#C5D4D3;190 85 10|#BDD8D4;190 85 15|#B2DBD5;190 85 20|#A6DDD6;190 90 05|#DAE4E2;190 90 10|#D1E8E5;190 93 05|#E3ECEA;200 20 05|#2D3535;200 20 10|#253536;200 20 15|#1C3337;200 20 20|#14363B;200 20 23|#0A373E;200 30 05|#3F4848;200 30 10|#394B4D;200 30 15|#334D50;200 30 20|#2B4E52;200 30 25|#1C4C51;200 30 30|#0C4E56;200 30 33|#014F5A;200 40 05|#555F60;200 40 10|#4F6162;200 40 15|#476265;200 40 20|#3F6468;200 40 25|#36666B;200 40 30|#2A666E;200 40 35|#186670;200 40 40|#0C6875;200 50 05|#6C7676;200 50 10|#677A7C;200 50 15|#5E7C7E;200 50 20|#557C81;200 50 25|#4C7E85;200 50 30|#407F87;200 50 35|#37828C;200 50 40|#27828E;200 50 45|#128191;200 60 05|#869191;200 60 10|#7F9394;200 60 15|#779599;200 60 20|#6F979C;200 60 25|#65989E;200 60 30|#5B9AA0;200 60 35|#539AA5;200 60 40|#489CA8;200 70 05|#A1ABAB;200 70 10|#99AFB0;200 70 15|#8FAFB2;200 70 20|#88B3B5;200 70 25|#80B5BB;200 80 05|#BEC7C6;200 80 10|#B3CACB;200 80 15|#AACACA;200 80 20|#A3CFD1;200 80 25|#9BD0D5;200 85 05|#C7D5D3;200 85 10|#C2D9D8;200 85 15|#B9DCDB;200 85 20|#B0DEDE;200 90 05|#DCE7E3;200 90 10|#D1E8E4;200 93 05|#E3EEEA;2000|#C7750F;2001|#A74D23;2002|#AC3721;2003|#E17C30;2004|#CC5608;2005|#FF4612;2007|#FFAD19;2008|#D66C21;2009|#C9560D;2010|#BC602D;2011|#CF7421;2012|#C2674F;2013|#824128;2017|#DC5B00;210 30 10|#39494D;210 30 15|#314B51;210 30 20|#274D56;210 30 25|#1E4C59;210 30 30|#104B5D;210 40 10|#4D5F64;210 40 15|#466269;210 40 20|#3D636C;210 40 25|#32626E;210 40 30|#206374;210 40 35|#11647A;210 40 38|#06617A;210 50 10|#65787D;210 50 15|#5E7A80;210 50 20|#537B85;210 50 25|#4A7D89;210 50 30|#3D7C8E;210 50 35|#367E92;210 50 40|#207E96;210 50 45|#107D9A;210 60 10|#7E9296;210 60 15|#749399;210 60 20|#6E97A1;210 60 25|#6499A6;210 60 30|#5A99AA;210 60 35|#4F99AD;210 60 40|#4099B2;210 70 10|#98AEB1;210 70 15|#90AFB5;210 70 20|#87B1BB;210 70 25|#7EB2BF;210 70 30|#75B4C5;210 70 35|#6BB5C9;210 80 10|#B7CBCE;210 80 15|#ADCDD2;210 80 20|#A3CDD6;210 80 25|#9BCFDC;210 85 05|#C7D4D6;210 85 10|#BDDADC;210 85 15|#B9DBDE;210 85 20|#B0DCE0;210 90 05|#D9E4E5;210 90 10|#CFE6E6;220 20 05|#2B3236;220 20 10|#25343B;220 20 15|#1A343E;220 20 20|#143543;220 30 05|#3F474A;220 30 10|#394A4F;220 30 15|#344C56;220 30 20|#2A4C59;220 30 25|#1C4D5F;220 30 30|#0B4A63;220 40 05|#555F61;220 40 10|#4F6066;220 40 15|#47616D;220 40 20|#3F6271;220 40 25|#356376;220 40 30|#2B637E;220 40 35|#1C6482;220 40 40|#0E6487;220 50 05|#6F787B;220 50 10|#68787F;220 50 15|#5E7A85;220 50 20|#557B89;220 50 25|#4D7B8E;220 50 30|#407A93;220 50 35|#377D9A;220 50 40|#277DA0;220 60 05|#869092;220 60 10|#7F9199;220 60 15|#78949F;220 60 20|#6D94A5;220 60 25|#6495AA;220 60 30|#5C98B1;220 60 35|#5196B3;220 60 40|#4696BA;220 70 05|#A1ABAF;220 70 10|#9BAEB5;220 70 15|#92B0BB;220 70 20|#89B1C0;220 70 25|#7EB0C5;220 70 30|#74B0C8;220 70 35|#6AB2D1;220 80 05|#BCC6C9;220 80 10|#B6CBD2;220 80 15|#A9C9D5;220 80 20|#A5CDDE;220 80 25|#9ECFE2;220 85 05|#CBD6D9;220 85 10|#C1D7DF;220 85 15|#B8D9E4;220 90 05|#D9E5E6;220 90 10|#CEE4E7;230 20 10|#27353D;230 20 15|#213542;230 20 20|#133246;230 30 10|#3D4B53;230 30 15|#334A57;230 30 20|#2B4A5D;230 30 25|#214B64;230 40 10|#505F69;230 40 15|#49606E;230 40 20|#416275;230 40 25|#35607B;230 40 30|#2E6282;230 40 35|#176189;230 40 40|#0C608D;230 50 10|#677881;230 50 15|#607A88;230 50 20|#597B8F;230 50 25|#507A94;230 50 30|#437C9D;230 50 35|#3B7AA1;230 50 40|#2779A8;230 60 10|#81939D;230 60 15|#7892A1;230 60 20|#7093A9;230 60 25|#6692AF;230 60 30|#5D92B4;230 60 35|#5394BE;230 60 40|#4593C4;230 70 10|#9DAEB9;230 70 15|#92AFBE;230 70 20|#89AEC5;230 70 25|#83AFCC;230 70 30|#78B0D2;230 80 10|#B7C9D4;230 80 15|#ADC7D7;230 80 20|#A6CAE0;230 85 05|#CBD4DB;230 85 10|#C1D4E0;230 85 15|#BBD6E7;230 85 20|#B3D8EE;230 90 05|#DAE3E5;240 20 05|#2E3438;240 20 10|#27333D;240 20 15|#223444;240 20 20|#18334A;240 20 22|#11314B;240 30 05|#41484D;240 30 10|#3B4954;240 30 15|#364A5B;240 30 20|#2D4960;240 30 25|#1E4867;240 30 30|#12486D;240 30 35|#0B4872;240 40 05|#565E64;240 40 10|#515F6B;240 40 15|#4A6073;240 40 20|#405F78;240 40 25|#386080;240 40 30|#2C5E87;240 40 35|#125E8D;240 40 40|#0A5D94;240 50 05|#6F777C;240 50 10|#677683;240 50 15|#60788B;240 50 20|#577792;240 50 25|#4F7899;240 50 30|#4677A0;240 50 35|#3676A7;240 50 40|#2A75AD;240 60 05|#879097;240 60 10|#7E8F9C;240 60 15|#7890A4;240 60 20|#7192AD;240 60 25|#6992B4;240 60 30|#5E91BC;240 60 35|#5491C3;240 60 40|#4A92C7;240 70 05|#A2AAB1;240 70 10|#9BABB8;240 70 15|#93ACC1;240 70 20|#8BACC7;240 70 25|#84ADCF;240 70 30|#78ABD5;240 80 05|#BCC5CB;240 80 10|#B8C8D6;240 80 15|#B0C8DD;240 80 20|#A7C9E5;240 85 05|#CBD4DB;240 85 10|#C3D4E2;240 85 15|#BBD5EA;240 90 05|#DAE3E9;240 90 10|#D1E5EF;250 20 20|#17304B;250 20 25|#112E50;250 30 15|#34465A;250 30 20|#2C4662;250 30 25|#25476A;250 30 30|#144571;250 40 10|#525E6C;250 40 15|#4B5E74;250 40 20|#435D79;250 40 25|#3A5D82;250 40 30|#2E5D8A;250 40 35|#1F5B90;250 40 40|#155B95;250 50 10|#697684;250 50 15|#62758C;250 50 20|#5C7693;250 50 25|#54759B;250 50 30|#4B74A4;250 50 35|#4074AC;250 50 40|#3074B4;250 60 10|#818E9E;250 60 15|#7C8FA7;250 60 20|#748EAF;250 60 25|#6D8EB7;250 60 30|#648EBE;250 60 35|#5C8DC7;250 60 40|#548ECF;250 70 10|#9CAABA;250 70 15|#96AAC2;250 70 20|#8FA9CA;250 70 25|#89AAD2;250 70 30|#80A9D9;250 80 10|#B9C6D6;250 80 15|#B4C8DE;250 80 20|#A9C3E4;250 85 05|#CAD0D8;250 85 10|#C4D1E2;250 85 15|#BFD3EA;250 90 05|#DBE1E8;260 20 05|#2F343A;260 20 10|#2B333F;260 20 15|#223045;260 20 20|#1E314B;260 30 05|#42474E;260 30 10|#3F4756;260 30 15|#3A475C;260 30 20|#344663;260 30 25|#2A4569;260 30 30|#254672;260 30 35|#14437B;260 40 05|#585D64;260 40 10|#565F6E;260 40 15|#515E75;260 40 20|#485B7A;260 40 25|#435C83;260 40 30|#3D5C89;260 40 35|#335A90;260 40 40|#205A9B;260 40 45|#1458A2;260 50 05|#6F747C;260 50 10|#6C7484;260 50 15|#67748C;260 50 20|#647694;260 50 25|#5D759E;260 50 30|#5574A7;260 50 35|#4C72AC;260 50 40|#4373B7;260 60 05|#888E96;260 60 10|#848D9E;260 60 15|#8390A9;260 60 20|#7B8EAF;260 60 25|#768EB7;260 60 30|#708EC0;260 60 35|#678DC8;260 70 05|#A6ABB3;260 70 10|#A1AABB;260 70 15|#9AA9C3;260 70 20|#96A9CC;260 70 25|#8EA8D4;260 80 05|#C0C5CE;260 80 10|#BBC4D6;260 80 15|#B5C4DE;260 85 05|#CCD0D8;260 85 10|#C8D2E4;260 90 05|#DCE0E5;270 20 20|#212E4C;270 20 25|#192C52;270 20 29|#132C5B;270 30 15|#3C455C;270 30 20|#384463;270 30 25|#32446B;270 30 30|#2A4171;270 30 35|#21407A;270 30 40|#163D81;270 40 15|#545C74;270 40 20|#4E5B7C;270 40 25|#4B5B84;270 40 30|#44588B;270 40 35|#3C5793;270 40 40|#33559A;270 50 10|#6E7586;270 50 15|#6C758F;270 50 20|#677396;270 50 25|#63739E;270 50 30|#5C70A6;270 50 35|#556EAB;270 50 40|#4F6FB6;270 60 10|#868D9F;270 60 15|#858EA9;270 60 20|#808CB1;270 60 25|#7B8CB9;270 60 30|#778BC2;270 60 35|#6F88C8;270 70 10|#A3A9BC;270 70 15|#9FA8C4;270 70 20|#9CA8CE;270 70 25|#94A4D3;270 80 10|#BFC4D7;270 80 15|#B9C1DE;270 85 05|#CED0D7;270 85 10|#CACFE3;270 85 15|#C5CEE9;270 90 05|#DEE0E8;280 20 05|#33343A;280 20 10|#303241;280 20 15|#2D3146;280 20 20|#282F4B;280 20 25|#252F53;280 20 30|#202D59;280 30 05|#44464D;280 30 10|#444756;280 30 15|#42455E;280 30 20|#3F4565;280 30 25|#3B436B;280 30 30|#344171;280 30 35|#324077;280 30 40|#2C407E;280 40 05|#5B5D64;280 40 10|#595B6C;280 40 15|#565A73;280 40 20|#54597C;280 40 25|#525984;280 40 30|#4E578A;280 40 35|#495691;280 40 40|#425499;280 40 45|#3A52A0;280 50 05|#72757E;280 50 10|#717485;280 50 15|#6F728C;280 50 20|#6C7095;280 50 25|#69709D;280 50 30|#666EA4;280 50 35|#626DAB;280 50 40|#5E6DB6;280 60 05|#8B8D96;280 60 10|#898B9E;280 60 15|#888AA6;280 60 20|#868AAF;280 60 25|#8288B7;280 60 30|#8088BE;280 60 35|#7C87C8;280 70 05|#A5A6B0;280 70 10|#A6A8BA;280 70 15|#A3A6C2;280 70 20|#A1A5CC;280 70 25|#9EA4D3;280 80 05|#C4C5CE;280 80 10|#C1C2D5;280 80 15|#BBBFDC;280 85 05|#CFD1D8;280 85 10|#CBD0E1;280 90 05|#DEE0E9;280 93 05|#E7E9F1;290 20 10|#2C2C3C;290 20 15|#2F2D42;290 20 20|#2F2F4C;290 20 25|#2B2B51;290 20 30|#252855;290 20 35|#23275D;290 30 10|#444253;290 30 15|#44425A;290 30 20|#413F60;290 30 25|#403E68;290 30 30|#3E3D6F;290 30 35|#3C3D77;290 30 40|#383A7D;290 40 10|#5B5A6B;290 40 15|#5B5872;290 40 20|#59567B;290 40 25|#575380;290 40 30|#545187;290 40 35|#524F8E;290 40 40|#504F97;290 40 45|#4C4E9E;290 50 10|#727184;290 50 15|#716F89;290 50 20|#706C92;290 50 25|#706B9A;290 50 30|#6E6AA1;290 50 35|#6B68A9;290 50 40|#6967B1;290 60 10|#8B899E;290 60 15|#8B88A5;290 60 20|#8884AD;290 60 25|#8985B6;290 60 30|#8783BD;290 60 35|#8280C3;290 70 10|#A7A5BA;290 70 15|#A6A2C2;290 70 20|#A4A1C9;290 70 25|#A29ED1;290 80 10|#C2C0D4;290 80 15|#C2BFDB;290 85 05|#D4D2D9;290 85 10|#CECDE7;290 90 05|#E0E0E7;290 93 05|#E7E7EF;300 20 05|#343239;300 20 10|#312D3C;300 20 15|#312C42;300 20 20|#312A47;300 20 25|#30284B;300 20 30|#2E2653;300 30 05|#47454D;300 30 10|#474254;300 30 15|#474058;300 30 20|#473E5E;300 30 25|#483D65;300 30 30|#473B6B;300 30 35|#463A71;300 30 40|#443777;300 40 05|#5E5C64;300 40 10|#5D5869;300 40 15|#5D566F;300 40 20|#5E5476;300 40 25|#5E527D;300 40 30|#5F5084;300 40 35|#5E4F88;300 40 40|#5B4B8E;300 40 45|#5B4A96;300 50 05|#74737B;300 50 10|#767082;300 50 15|#766E89;300 50 20|#776C90;300 50 25|#776996;300 50 30|#77679D;300 50 35|#7866A4;300 50 40|#7663AB;300 60 05|#8E8D96;300 60 10|#8F899C;300 60 15|#9087A3;300 60 20|#9084AA;300 60 25|#9081B0;300 60 30|#907FB8;300 60 35|#8F7CBE;300 70 05|#A9A7B1;300 70 10|#AAA3B7;300 70 15|#ABA1BF;300 70 20|#ACA0C6;300 70 25|#AC9CCD;300 80 05|#C6C3CC;300 80 10|#C4BED4;300 80 15|#C7BDDB;300 85 05|#D2CFD6;300 85 10|#D5CBE1;300 90 05|#E1DFE8;3000|#962A27;3001|#8F1E24;3002|#8D1F24;3003|#7C0D24;3004|#651927;3005|#561E27;3007|#3D2326;3009|#643730;3011|#6E2124;3012|#B7856E;3013|#8A2F28;3014|#BC6F72;3015|#CC9EA4;3016|#963D2F;3017|#B9535B;3018|#B63C49;3020|#AB1519;3022|#BE6954;3024|#EE1729;3026|#F71027;3027|#9E1B3C;3028|#B92726;3031|#973238;3032|#661925;3033|#94352D;310 20 20|#382C46;310 20 25|#3B2A4C;310 20 30|#392650;310 30 15|#4E4359;310 30 20|#4D3E5C;310 30 25|#4F3C62;310 30 30|#523968;310 30 35|#51376A;310 30 40|#533671;310 40 10|#635B6B;310 40 15|#655971;310 40 20|#675776;310 40 25|#68537B;310 40 30|#674F7E;310 40 35|#694E84;310 40 40|#6C4C8A;310 50 10|#7A7183;310 50 15|#7C6F89;310 50 20|#7F6D8E;310 50 25|#806A94;310 50 30|#82689A;310 50 35|#82659E;310 50 40|#8363A4;310 60 10|#92899C;310 60 15|#9688A2;310 60 20|#9985A8;310 60 25|#9B82AD;310 60 30|#9D80B2;310 60 35|#9E7CBA;310 70 10|#AEA4B5;310 70 15|#B1A1BC;310 70 20|#B29EC1;310 70 25|#B49CC7;310 80 10|#C9BFD1;310 80 15|#CDBDD8;310 85 05|#D4D1D8;310 85 10|#D8CDE0;310 90 05|#E6E1E7;320 20 05|#363239;320 20 10|#372D3A;320 20 15|#382A3E;320 20 20|#3D2742;320 20 25|#3C2445;320 30 05|#49444B;320 30 10|#4C424F;320 30 15|#4D3D52;320 30 20|#503956;320 30 25|#54375B;320 30 30|#553560;320 30 35|#583264;320 30 37|#5A3168;320 40 05|#615C63;320 40 10|#625866;320 40 15|#66556B;320 40 20|#685270;320 40 25|#6A4F74;320 40 30|#6D4977;320 40 35|#70467B;320 40 40|#734382;320 50 05|#767279;320 50 10|#7A6E7E;320 50 15|#7D6B83;320 50 20|#826A88;320 50 25|#83648D;320 50 30|#876393;320 50 35|#895C95;320 50 40|#8C5D9B;320 60 05|#918C94;320 60 10|#948998;320 60 15|#98869E;320 60 20|#9B80A2;320 60 25|#9D7EA7;320 60 30|#A17AAD;320 60 35|#A477B0;320 70 05|#ABA5AE;320 70 10|#AEA1B4;320 70 15|#B19EB9;320 70 20|#B99DC1;320 70 25|#BB97C4;320 80 05|#C8C1C9;320 80 10|#CCBECF;320 80 15|#CFB9D3;320 85 05|#D4CED6;320 85 10|#DACBDD;320 90 05|#E6DFE5;330 20 20|#40283E;330 20 25|#452543;330 30 15|#523F51;330 30 20|#563C54;330 30 25|#593857;330 30 30|#5E355A;330 30 35|#63315E;330 30 40|#652A5F;330 40 10|#665966;330 40 15|#6A5669;330 40 20|#6E546E;330 40 25|#725071;330 40 30|#784C74;330 40 35|#7C4978;330 40 40|#7C4278;330 40 45|#813D7A;330 50 10|#7D6F7D;330 50 15|#836D82;330 50 20|#876A86;330 50 25|#8B6789;330 50 30|#90648E;330 50 35|#936091;330 50 40|#985A92;330 60 10|#978998;330 60 15|#9D869D;330 60 20|#A283A0;330 60 25|#A47EA1;330 60 30|#A97BA6;330 60 35|#AF76AA;330 60 40|#B273AE;330 70 10|#B3A3B3;330 70 15|#B69FB5;330 70 20|#BD9CBA;330 70 25|#C398BE;330 70 30|#C695BF;330 80 10|#CFBECD;330 80 15|#D3BBD1;330 80 20|#DCB8D5;330 85 05|#D7D1D8;330 85 10|#DECCDC;330 85 15|#E3C9DF;330 90 05|#E9E0E4;340 20 05|#363035;340 20 10|#392B34;340 20 15|#3B2534;340 20 20|#41263A;340 20 25|#48263D;340 30 05|#4A4449;340 30 10|#4F3F4A;340 30 15|#533C4C;340 30 20|#57394D;340 30 25|#5D3552;340 30 30|#5F3052;340 30 35|#632954;340 30 38|#682455;340 40 05|#60595F;340 40 10|#665661;340 40 15|#6B5363;340 40 20|#704F65;340 40 25|#754B69;340 40 30|#79476B;340 40 35|#7B406C;340 40 40|#7F3C6D;340 40 45|#893371;340 50 05|#797277;340 50 10|#806E7A;340 50 15|#856A7C;340 50 20|#8A677E;340 50 25|#8E6281;340 50 30|#935E83;340 50 35|#975886;340 50 40|#9E5388;340 50 45|#A34D89;340 60 05|#948C92;340 60 10|#998793;340 60 15|#A08497;340 60 20|#A47F99;340 60 25|#A87A9A;340 60 30|#AD779E;340 60 35|#B473A0;340 60 40|#B86FA1;340 70 05|#ADA5AB;340 70 10|#B3A1AE;340 70 15|#BB9DB2;340 70 20|#BF9AB4;340 70 25|#C495B4;340 70 30|#CB90B9;340 70 35|#D18DBB;340 80 05|#CBC2C6;340 80 10|#D2BFCB;340 80 15|#D7BACD;340 80 20|#DEB7CF;340 85 05|#D7CED4;340 85 10|#E0CBD9;340 85 15|#E8C9DC;340 90 05|#E9DFE2;340 93 05|#EFE6ED;350 20 10|#392C34;350 20 15|#3E2934;350 20 20|#442435;350 20 25|#472136;350 20 30|#521C39;350 30 10|#4F4047;350 30 15|#553E49;350 30 20|#5B3A4A;350 30 25|#5F354B;350 30 30|#65324C;350 30 35|#682A4C;350 30 40|#6C224D;350 40 10|#685860;350 40 15|#6D5460;350 40 20|#725062;350 40 25|#764C62;350 40 30|#7D4863;350 40 35|#814264;350 40 40|#863F65;350 40 45|#8A3765;350 40 50|#922D66;350 50 10|#806E77;350 50 15|#866B78;350 50 20|#8C677A;350 50 25|#92637B;350 50 30|#97617D;350 50 35|#9F5A7C;350 50 40|#A1557B;350 50 45|#A6507E;350 50 50|#B14A7E;350 60 10|#9A8892;350 60 15|#A08492;350 60 20|#A88195;350 60 25|#AE7C94;350 60 30|#B57996;350 60 35|#B97396;350 60 40|#C06F97;350 60 45|#C36B99;350 70 10|#B6A3AB;350 70 15|#BC9EAC;350 70 20|#C098AC;350 70 25|#CA97AF;350 70 30|#D192B0;350 70 35|#D78EB1;350 80 10|#D2BDC6;350 80 15|#D9BAC7;350 80 20|#E0B6CB;350 85 05|#D8CED4;350 85 10|#E2CCD6;350 85 15|#E8C8D6;350 90 05|#EADFE1;350 90 10|#F0DAE5;350 93 05|#F1E6EB;360 20 15|#40282E;360 30 05|#4B4446;360 30 10|#503F45;360 30 15|#553B44;360 30 20|#5C3945;360 30 25|#5F3445;360 30 30|#642F44;360 30 35|#6A2942;360 30 40|#712444;360 40 05|#625A5D;360 40 10|#67565D;360 40 15|#6C525B;360 40 20|#734F5C;360 40 25|#784A5B;360 40 30|#7F465B;360 40 35|#85425C;360 40 40|#8B3D5C;360 40 45|#8F355A;360 40 50|#942A58;360 50 05|#7C7275;360 50 10|#806E75;360 50 15|#876A74;360 50 20|#8C6775;360 50 25|#946273;360 50 30|#9A5F75;360 50 35|#A25974;360 50 40|#A85773;360 50 45|#B05074;360 50 50|#B14A72;360 60 05|#958D90;360 60 10|#9A878E;360 60 15|#A1848E;360 60 20|#A9818F;360 60 25|#AE7B8E;360 70 05|#B0A7AA;360 70 10|#B6A1A8;360 70 15|#BE9EA8;360 80 05|#CDC2C5;360 80 10|#D3BEC4;360 80 15|#DCBAC5;360 85 05|#DCD1D2;360 85 10|#E3CCD3;360 90 05|#EDE0E1;360 90 10|#F2DAE0;360 93 05|#F3E6E9;4001|#7C5B80;4002|#823A4B;4003|#B65A88;4004|#5F1837;4005|#746395;4006|#852E6F;4007|#44263C;4008|#7C477D;4009|#95838F;4010|#AC3B71;4011|#685C80;4012|#67657A;5000|#35496B;5001|#294763;5002|#193278;5003|#203151;5004|#1E222C;5005|#134A85;5007|#466589;5008|#2F3A44;5009|#365875;5010|#0E457A;5011|#222C3E;5012|#457FB3;5013|#212F51;5014|#667691;5015|#3172AD;5017|#0F518A;5018|#47848D;5019|#265682;5020|#113E4D;5021|#216D76;5022|#282C58;5023|#4D648A;5024|#6C8DAA;5025|#3C6379;5026|#1B2B4D;6000|#4A7363;6001|#40693A;6002|#3B5B2F;6003|#4F553E;6004|#214245;6005|#234235;6006|#3C3D32;6007|#2E3526;6008|#333327;6009|#2A372C;6010|#4E6E39;6011|#6A7C5B;6012|#2F3B39;6013|#777659;6014|#454339;6015|#3C3F38;6016|#256753;6017|#5C8144;6018|#689A45;6019|#B8CFAD;6020|#3B4634;6021|#899B79;6022|#3B382E;6024|#3A8258;6025|#5D703E;6026|#0D5951;6027|#88B5B3;6028|#3D5547;6029|#226C45;6032|#417E57;6033|#568480;6034|#86A9AD;6035|#2E4F31;6036|#27514A;6037|#3F8C3D;6038|#20A339;6039|#ABC251;7000|#7B858D;7001|#8B949B;7002|#7D7965;7003|#76776A;7004|#969799;7005|#696D6B;7006|#716C60;7008|#6C6040;7009|#5B6058;7010|#575B57;7011|#535A5E;7012|#595E60;7013|#545146;7015|#51535A;7016|#3B4044;7021|#323537;7022|#4C4C47;7023|#7D7F76;7024|#45494E;7026|#394345;7030|#8C8C83;7031|#5D676D;7032|#B1B1A1;7033|#7C8273;7034|#8C8870;7035|#C2C6C3;7036|#949292;7037|#797B7B;7038|#ADB0A9;7039|#68675F;7040|#969CA1;7042|#8C9190;7043|#4F5352;7044|#B3B2A9;7045|#8C9094;7046|#7C8287;7047|#C5C5C5;7048|#7A7871;8000|#816D44;8001|#8F6833;8002|#704F40;8003|#74502F;8004|#814D37;8007|#67492F;8008|#694F2B;8011|#533A29;8012|#5C3128;8014|#453729;8015|#57332B;8016|#483026;8017|#42332E;8019|#3B3736;8022|#201F20;8023|#965D33;8024|#6F543C;8025|#6E5B4B;8028|#4C3E30;8029|#764537;9001|#E5E1D4;9002|#D4D5CD;9003|#EBECEA;9004|#2F3133;9005|#131516;9006|#9A9D9D;9007|#828280;9010|#EFEEE5;9011|#25282A;9012|#F2F1E1;9016|#EFF0EB;9017|#262625;9018|#C6CBC6;9022|#818382;9023|#767779';

const RAL_ALL_COLORS = Object.fromEntries(
    [
        ...RAL_ALL_COLOR_SOURCE.split(';'),
        // Additional manufacturer-listed shades: published screen approximations.
        // https://www.farbenbote.de/pages/farbtonkarte-ral-design
        // 290 92 05: https://onestopaerosols.co.uk/ral-design-paint/ral-290-92-05-aerosol-spray-paint/
        '010 92 05|#F2E5E3',
        '030 20 10|#433231',
        '040 20 05|#3D3634',
        '040 20 10|#41322F',
        '050 92 05|#F1E4DC',
        '060 20 10|#413833',
        '070 20 10|#3E352C',
        '075 20 10|#3C342A',
        '075 30 10|#51473B',
        '075 30 20|#594631',
        '075 92 05|#EFE6DB',
        '085 20 10|#433F36',
        '085 30 10|#514B3F',
        '085 30 20|#53462C',
        '090 20 10|#413D33',
        '095 20 10|#38352B',
        '095 30 10|#4E4A3D',
        '095 30 18|#504B34',
        '100 20 10|#2B3931',
        '110 90 35|#E2E7A1',
        '110 92 05|#E9E8DB',
        '120 20 05|#353732',
        '120 20 10|#303326',
        '130 20 10|#343B32',
        '130 92 05|#E5E9DD',
        '150 20 10|#2B3931',
        '160 30 38|#005637',
        '160 70 49|#48BE8B',
        '170 92 05|#DFEAE1',
        '180 30 36|#00574A',
        '190 20 10|#213736',
        '190 20 15|#143937',
        '190 30 10|#374D4B',
        '200 70 30|#58BBBC',
        '200 70 35|#40BCBD',
        '200 92 05|#DDEAE7',
        '210 20 10|#23383B',
        '210 20 15|#12373B',
        '220 92 05|#DDEAE9',
        '250 20 10|#2B3944',
        '250 20 15|#223848',
        '250 30 10|#3C4C57',
        '250 92 05|#E0E9EB',
        '270 20 10|#353D48',
        '270 20 15|#2C394A',
        '270 30 10|#404A58',
        '270 30 45|#004C86',
        '270 40 10|#5A6371',
        '290 92 05|#E8E7F1',
        '310 20 10|#3A3440',
        '310 20 15|#3A3144',
        '310 30 10|#4B4452',
        '320 50 39|#9267A0',
        '330 20 10|#413741',
        '330 20 15|#413241',
        '330 30 10|#534651',
        '340 92 05|#F1E4E7',
        '360 20 05|#3A3134',
        '360 20 10|#402E33',
        '360 92 05|#F1E4E4'
    ]
        .filter(Boolean)
        .map((entry) => {
            const [code, hex] = entry.split('|');
            return [code, hex.toUpperCase()];
        })
);

// Manufacturer approval: mögliche RAL Töne_07092026.xlsx, sheet RAL, A2:B2079.
// 2,078 rows -> 2,061 distinct codes after whitespace/neutral-grey normalization.
// This positive list supersedes the former metallic exclusion (including 9006/9007).
const RAL_PRODUCER_CODES = new Set(`
000 15 00;000 20 00;000 25 00;000 30 00;000 35 00;000 40 00;000 45 00;000 50 00;000 55 00;000 60 00;000 65 00;000 70 00;000 75 00;000 80 00;
000 85 00;000 90 00;010 20 10;010 20 15;010 20 20;010 20 25;010 30 10;010 30 15;010 30 20;010 30 25;010 30 30;010 30 35;010 30 40;010 30 44;
010 40 10;010 40 15;010 40 20;010 40 25;010 40 30;010 40 35;010 40 40;010 40 45;010 40 50;010 40 53;010 50 10;010 50 15;010 50 20;010 50 25;
010 50 30;010 50 35;010 50 40;010 50 45;010 50 50;010 60 10;010 60 15;010 60 20;010 60 25;010 60 30;010 60 35;010 60 40;010 60 45;010 70 10;
010 70 15;010 70 20;010 70 25;010 70 30;010 70 35;010 80 10;010 80 15;010 80 20;010 85 05;010 85 10;010 85 15;010 85 20;010 90 05;010 90 10;
010 92 05;010 93 05;020 20 05;020 20 10;020 20 20;020 20 29;020 30 05;020 30 10;020 30 20;020 30 30;020 30 40;020 30 48;020 40 05;020 40 10;
020 40 20;020 40 30;020 40 40;020 40 50;020 50 05;020 50 10;020 50 20;020 50 30;020 50 40;020 50 50;020 50 58;020 60 05;020 60 10;020 60 20;
020 60 30;020 60 40;020 70 05;020 70 10;020 70 20;020 70 30;020 80 05;020 80 10;020 80 20;020 85 05;020 85 10;020 85 20;020 90 05;020 90 10;
020 93 05;030 20 10;030 30 10;030 30 20;030 30 30;030 30 40;030 30 45;030 40 10;030 40 20;030 40 30;030 40 40;030 40 50;030 40 60;030 50 10;
030 50 20;030 50 30;030 50 40;030 50 50;030 50 60;030 60 10;030 60 20;030 60 30;030 60 40;030 60 50;030 70 10;030 70 20;030 70 30;030 70 40;
030 80 10;030 80 20;030 85 05;030 85 10;030 85 20;030 90 05;030 90 10;030 93 05;040 20 05;040 20 10;040 20 19;040 30 05;040 30 10;040 30 20;
040 30 30;040 30 40;040 40 05;040 40 10;040 40 20;040 40 30;040 40 40;040 40 50;040 40 60;040 40 67;040 50 05;040 50 10;040 50 20;040 50 30;
040 50 40;040 50 50;040 50 60;040 50 70;040 60 05;040 60 10;040 60 20;040 60 30;040 60 40;040 60 50;040 60 60;040 70 05;040 70 10;040 70 20;
040 70 30;040 70 40;040 70 50;040 80 05;040 80 10;040 80 20;040 80 30;040 85 05;040 85 10;040 85 20;040 90 05;040 90 10;040 93 05;050 20 10;
050 20 16;050 30 10;050 30 20;050 30 30;050 30 36;050 40 10;050 40 20;050 40 30;050 40 40;050 40 50;050 50 10;050 50 20;050 50 30;050 50 40;
050 50 50;050 50 60;050 50 70;050 50 78;050 60 10;050 60 20;050 60 30;050 60 40;050 60 50;050 60 60;050 60 70;050 60 80;050 70 10;050 70 20;
050 70 30;050 70 40;050 70 50;050 70 60;050 80 10;050 80 20;050 80 30;050 85 05;050 85 10;050 85 20;050 90 05;050 90 10;050 92 05;050 93 05;
060 20 05;060 20 10;060 30 05;060 30 10;060 30 20;060 30 27;060 40 05;060 40 10;060 40 20;060 40 30;060 40 40;060 50 05;060 50 10;060 50 20;
060 50 30;060 50 40;060 50 50;060 50 60;060 50 70;060 60 05;060 60 10;060 60 20;060 60 30;060 60 50;060 60 60;060 60 70;060 60 80;060 70 05;
060 70 10;060 70 20;060 70 30;060 70 40;060 70 50;060 70 60;060 70 70;060 80 05;060 80 10;060 80 20;060 80 30;060 80 40;060 85 05;060 85 10;
060 85 20;060 85 30;060 90 05;060 90 10;060 90 15;060 93 05;070 20 10;070 30 10;070 30 20;070 40 10;070 40 20;070 40 30;070 40 40;070 50 10;
070 50 20;070 50 30;070 50 40;070 50 50;070 50 55;070 60 10;070 60 20;070 60 30;070 60 40;070 60 50;070 60 60;070 60 70;070 60 75;070 70 10;
070 70 20;070 70 30;070 70 40;070 70 50;070 70 60;070 70 70;070 70 80;070 80 10;070 80 20;070 80 30;070 80 40;070 80 50;070 80 60;070 85 05;
070 85 10;070 85 20;070 85 30;070 90 05;070 90 10;070 90 20;070 93 05;075 20 10;075 30 10;075 30 20;075 40 10;075 40 20;075 40 30;075 40 38;
075 50 10;075 50 20;075 50 30;075 50 40;075 50 50;075 50 58;075 60 10;075 60 20;075 60 30;075 60 40;075 60 50;075 60 60;075 60 70;075 70 10;
075 70 20;075 70 30;075 70 40;075 70 50;075 70 60;075 70 70;075 70 80;075 80 10;075 80 20;075 80 30;075 80 40;075 80 50;075 80 60;075 90 10;
075 90 20;075 92 05;080 20 05;080 20 10;080 30 05;080 30 10;080 30 20;080 30 26;080 40 05;080 40 10;080 40 20;080 40 30;080 40 40;080 50 05;
080 50 10;080 50 20;080 50 30;080 50 40;080 50 50;080 60 05;080 60 10;080 60 20;080 60 30;080 60 40;080 60 50;080 60 60;080 60 70;080 70 05;
080 70 10;080 70 20;080 70 30;080 70 40;080 70 50;080 70 60;080 70 70;080 70 80;080 70 88;080 80 05;080 80 10;080 80 20;080 80 30;080 80 40;
080 80 50;080 80 60;080 80 70;080 80 80;080 80 90;080 85 05;080 85 10;080 85 20;080 85 30;080 85 40;080 90 05;080 90 10;080 90 20;080 90 30;
080 93 05;085 20 10;085 30 10;085 30 20;085 40 10;085 40 20;085 40 30;085 50 10;085 50 20;085 50 30;085 50 40;085 50 50;085 60 10;085 60 20;
085 60 30;085 60 40;085 60 50;085 60 60;085 70 10;085 70 20;085 70 30;085 70 40;085 70 50;085 70 60;085 70 70;085 70 75;085 80 10;085 80 20;
085 80 30;085 80 40;085 80 50;085 80 60;085 80 70;085 80 80;085 80 85;085 85 10;085 85 20;085 85 30;085 85 40;085 90 10;085 90 20;085 93 05;
090 20 10;090 30 10;090 30 20;090 40 10;090 40 20;090 40 30;090 50 10;090 50 20;090 50 30;090 50 40;090 60 10;090 60 20;090 60 30;090 60 40;
090 60 50;090 60 60;090 70 10;090 70 20;090 70 30;090 70 40;090 70 50;090 70 60;090 70 70;090 70 80;090 80 10;090 80 20;090 80 30;090 80 40;
090 80 50;090 80 60;090 80 70;090 80 80;090 80 90;090 85 05;090 85 10;090 85 20;090 85 30;090 85 40;090 85 50;090 90 05;090 90 10;090 90 20;
090 90 30;090 90 40;090 90 50;090 90 60;090 93 05;095 20 10;095 30 10;095 30 18;095 40 10;095 40 20;095 40 30;095 50 10;095 50 20;095 50 30;
095 50 40;095 50 50;095 60 10;095 60 20;095 60 30;095 60 40;095 60 50;095 60 60;095 60 70;095 70 10;095 70 20;095 70 30;095 70 40;095 70 50;
095 70 60;095 70 70;095 80 10;095 80 20;095 80 30;095 80 40;095 80 50;095 80 60;095 80 70;095 80 80;095 85 20;095 85 30;095 85 40;095 85 50;
095 90 10;095 90 20;095 90 30;095 90 40;095 90 50;095 90 59;095 93 05;100 20 05;100 20 10;100 30 05;100 30 10;100 30 20;100 40 05;100 40 10;
100 40 20;100 40 30;100 40 40;100 50 05;100 50 10;100 50 20;100 50 30;100 50 40;100 50 50;100 60 05;100 60 10;100 60 20;100 60 30;100 60 40;
100 60 50;100 60 60;100 70 05;100 70 10;100 70 20;100 70 30;100 70 40;100 70 50;100 70 60;100 80 05;100 80 10;100 80 20;100 80 30;100 80 40;
100 80 50;100 80 60;100 80 70;100 80 80;100 85 05;100 85 10;100 85 20;100 85 30;100 90 05;100 90 10;100 90 20;100 90 30;100 90 40;100 90 50;
100 93 05;1000;1001;1002;1003;1004;1005;1006;1007;1011;1012;1013;1014;1015;
1016;1017;1018;1019;1020;1021;1023;1024;1027;1028;1032;1033;1034;1037;
110 20 10;110 30 10;110 30 20;110 40 10;110 40 20;110 40 30;110 40 40;110 50 10;110 50 20;110 50 30;110 50 40;110 50 50;110 50 55;110 60 10;
110 60 20;110 60 30;110 60 40;110 60 50;110 60 60;110 60 65;110 70 10;110 70 20;110 70 30;110 70 40;110 70 50;110 70 60;110 70 70;110 70 77;
110 80 10;110 80 20;110 80 30;110 80 40;110 80 50;110 80 60;110 80 70;110 85 10;110 85 20;110 85 30;110 85 40;110 85 50;110 90 05;110 90 10;
110 90 20;110 90 30;110 90 35;110 92 05;110 93 05;110 96 02;120 20 05;120 20 10;120 30 05;120 30 10;120 30 20;120 40 05;120 40 10;120 40 20;
120 40 30;120 40 40;120 50 05;120 50 10;120 50 20;120 50 30;120 50 40;120 50 50;120 60 05;120 60 10;120 60 20;120 60 30;120 60 40;120 60 50;
120 60 60;120 60 63;120 70 05;120 70 10;120 70 20;120 70 30;120 70 40;120 70 50;120 70 60;120 70 70;120 70 75;120 80 05;120 80 10;120 80 20;
120 80 30;120 80 40;120 80 50;120 80 60;120 85 05;120 85 10;120 85 20;120 85 30;120 90 05;120 90 10;120 90 20;120 90 30;120 93 05;130 20 10;
130 30 10;130 30 20;130 40 10;130 40 20;130 40 30;130 50 10;130 50 20;130 50 30;130 50 40;130 50 50;130 60 10;130 60 20;130 60 30;130 60 40;
130 60 50;130 60 60;130 70 10;130 70 20;130 70 30;130 70 40;130 70 50;130 70 60;130 80 10;130 80 20;130 80 30;130 80 40;130 80 50;130 85 05;
130 85 10;130 85 20;130 85 30;130 90 05;130 90 10;130 90 20;130 92 05;130 93 05;140 20 05;140 20 10;140 20 20;140 30 05;140 30 10;140 30 20;
140 30 30;140 30 40;140 40 05;140 40 10;140 40 20;140 40 30;140 40 40;140 40 50;140 50 05;140 50 10;140 50 20;140 50 30;140 50 40;140 50 50;
140 50 60;140 60 05;140 60 10;140 60 20;140 60 30;140 60 40;140 60 50;140 60 60;140 60 70;140 70 05;140 70 10;140 70 20;140 70 30;140 70 40;
140 70 50;140 70 60;140 80 05;140 80 10;140 80 20;140 80 30;140 80 40;140 85 05;140 85 10;140 85 20;140 85 30;140 90 05;140 90 10;140 93 05;
150 20 10;150 30 10;150 30 20;150 30 30;150 40 10;150 40 20;150 40 30;150 40 40;150 40 50;150 50 10;150 50 20;150 50 30;150 50 40;150 50 50;
150 50 60;150 60 10;150 60 20;150 60 30;150 60 40;150 60 50;150 60 60;150 70 10;150 70 20;150 70 30;150 70 40;150 70 50;150 80 10;150 80 20;
150 80 30;150 80 40;150 85 05;150 85 10;150 85 20;150 90 05;150 90 10;150 93 05;160 20 05;160 20 10;160 20 15;160 20 20;160 30 05;160 30 10;
160 30 15;160 30 20;160 30 25;160 30 30;160 30 35;160 30 38;160 30 40;160 40 05;160 40 10;160 40 15;160 40 20;160 40 25;160 40 30;160 40 35;
160 40 40;160 40 45;160 40 50;160 40 55;160 50 05;160 50 10;160 50 15;160 50 20;160 50 25;160 50 30;160 50 35;160 50 40;160 50 45;160 50 50;
160 50 55;160 50 60;160 60 05;160 60 10;160 60 15;160 60 20;160 60 25;160 60 30;160 60 35;160 60 40;160 60 45;160 60 50;160 60 55;160 60 58;
160 70 05;160 70 10;160 70 15;160 70 20;160 70 25;160 70 30;160 70 35;160 70 40;160 70 45;160 70 49;160 70 50;160 80 05;160 80 10;160 80 15;
160 80 20;160 80 25;160 80 30;160 85 05;160 85 10;160 85 15;160 90 05;160 90 10;160 90 15;160 93 05;170 20 10;170 20 15;170 20 20;170 20 25;
170 30 10;170 30 15;170 30 20;170 30 25;170 30 30;170 30 35;170 30 40;170 40 10;170 40 15;170 40 20;170 40 25;170 40 30;170 40 35;170 40 40;
170 40 45;170 40 50;170 50 10;170 50 15;170 50 20;170 50 25;170 50 30;170 50 35;170 50 40;170 50 45;170 50 50;170 50 55;170 60 10;170 60 15;
170 60 20;170 60 25;170 60 30;170 60 35;170 60 40;170 60 45;170 60 50;170 70 10;170 70 15;170 70 20;170 70 25;170 70 30;170 70 35;170 70 40;
170 80 10;170 80 15;170 80 20;170 80 25;170 85 05;170 85 10;170 85 15;170 85 20;170 90 05;170 90 10;170 92 05;180 20 05;180 20 10;180 20 15;
180 20 20;180 30 05;180 30 10;180 30 15;180 30 20;180 30 25;180 30 30;180 30 35;180 30 36;180 40 05;180 40 10;180 40 15;180 40 20;180 40 25;
180 40 30;180 40 35;180 40 40;180 40 45;180 50 05;180 50 10;180 50 15;180 50 20;180 50 25;180 50 30;180 50 35;180 50 40;180 50 45;180 50 50;
180 60 05;180 60 10;180 60 15;180 60 20;180 60 25;180 60 30;180 60 35;180 60 40;180 60 45;180 60 50;180 70 05;180 70 10;180 70 15;180 70 20;
180 70 25;180 70 30;180 70 35;180 70 40;180 80 05;180 80 10;180 80 15;180 80 20;180 80 25;180 80 30;180 85 05;180 85 10;180 85 15;180 85 20;
180 90 05;180 90 10;180 93 05;190 20 10;190 20 15;190 20 20;190 30 10;190 30 15;190 30 20;190 30 25;190 30 30;190 30 35;190 40 10;190 40 15;
190 40 20;190 40 25;190 40 30;190 40 35;190 40 40;190 40 45;190 50 10;190 50 15;190 50 20;190 50 25;190 50 30;190 50 35;190 50 40;190 50 45;
190 60 10;190 60 15;190 60 20;190 60 25;190 60 30;190 60 35;190 60 40;190 60 45;190 70 10;190 70 15;190 70 20;190 70 25;190 70 30;190 70 35;
190 80 10;190 80 15;190 80 20;190 80 25;190 85 05;190 85 10;190 85 15;190 85 20;190 90 05;190 90 10;190 93 05;200 20 05;200 20 10;200 20 15;
200 20 20;200 20 23;200 30 05;200 30 10;200 30 15;200 30 20;200 30 25;200 30 30;200 30 33;200 40 05;200 40 10;200 40 15;200 40 20;200 40 25;
200 40 30;200 40 35;200 40 40;200 50 05;200 50 10;200 50 15;200 50 20;200 50 25;200 50 30;200 50 35;200 50 40;200 50 45;200 60 05;200 60 10;
200 60 15;200 60 20;200 60 25;200 60 30;200 60 35;200 60 40;200 70 05;200 70 10;200 70 15;200 70 20;200 70 25;200 70 30;200 70 35;200 80 05;
200 80 10;200 80 15;200 80 20;200 80 25;200 85 05;200 85 10;200 85 15;200 85 20;200 90 05;200 90 10;200 92 05;200 93 05;2000;2001;
2002;2003;2004;2008;2009;2010;2011;2012;210 20 10;210 20 15;210 30 10;210 30 15;210 30 20;210 30 25;
210 30 30;210 40 10;210 40 15;210 40 20;210 40 25;210 40 30;210 40 35;210 40 38;210 50 10;210 50 15;210 50 20;210 50 25;210 50 30;210 50 35;
210 50 40;210 50 45;210 60 10;210 60 15;210 60 20;210 60 25;210 60 30;210 60 35;210 60 40;210 70 10;210 70 15;210 70 20;210 70 25;210 70 30;
210 70 35;210 80 10;210 80 15;210 80 20;210 80 25;210 85 05;210 85 10;210 85 15;210 85 20;210 90 05;210 90 10;220 20 05;220 20 10;220 20 15;
220 20 20;220 30 05;220 30 10;220 30 15;220 30 20;220 30 25;220 30 30;220 40 05;220 40 10;220 40 15;220 40 20;220 40 25;220 40 30;220 40 35;
220 40 40;220 50 05;220 50 10;220 50 15;220 50 20;220 50 25;220 50 30;220 50 35;220 50 40;220 60 05;220 60 10;220 60 15;220 60 20;220 60 25;
220 60 30;220 60 35;220 60 40;220 70 05;220 70 10;220 70 15;220 70 20;220 70 25;220 70 30;220 70 35;220 80 05;220 80 10;220 80 15;220 80 20;
220 80 25;220 85 05;220 85 10;220 85 15;220 90 05;220 90 10;220 92 05;230 20 10;230 20 15;230 20 20;230 30 10;230 30 15;230 30 20;230 30 25;
230 40 10;230 40 15;230 40 20;230 40 25;230 40 30;230 40 35;230 40 40;230 50 10;230 50 15;230 50 20;230 50 25;230 50 30;230 50 35;230 50 40;
230 60 10;230 60 15;230 60 20;230 60 25;230 60 30;230 60 35;230 60 40;230 70 10;230 70 15;230 70 20;230 70 25;230 70 30;230 80 10;230 80 15;
230 80 20;230 85 05;230 85 15;230 85 20;230 90 05;240 20 05;240 20 10;240 20 15;240 20 20;240 20 22;240 30 05;240 30 10;240 30 15;240 30 20;
240 30 25;240 30 30;240 30 35;240 40 05;240 40 10;240 40 15;240 40 20;240 40 25;240 40 30;240 40 35;240 40 40;240 50 05;240 50 10;240 50 15;
240 50 20;240 50 25;240 50 30;240 50 35;240 50 40;240 60 05;240 60 10;240 60 15;240 60 20;240 60 25;240 60 30;240 60 35;240 60 40;240 70 05;
240 70 10;240 70 15;240 70 20;240 70 25;240 70 30;240 80 05;240 80 10;240 80 15;240 80 20;240 85 05;240 85 10;240 85 15;240 90 05;240 90 10;
250 20 10;250 20 15;250 20 20;250 20 25;250 30 10;250 30 15;250 30 20;250 30 25;250 30 30;250 40 10;250 40 15;250 40 20;250 40 25;250 40 30;
250 40 35;250 40 40;250 50 10;250 50 15;250 50 20;250 50 25;250 50 30;250 50 35;250 50 40;250 60 10;250 60 15;250 60 20;250 60 25;250 60 30;
250 60 35;250 60 40;250 70 10;250 70 15;250 70 20;250 70 25;250 70 30;250 80 10;250 80 15;250 80 20;250 85 05;250 85 10;250 85 15;250 90 05;
250 92 05;260 20 05;260 20 10;260 20 15;260 20 20;260 30 05;260 30 10;260 30 15;260 30 20;260 30 25;260 30 30;260 30 35;260 40 05;260 40 10;
260 40 15;260 40 20;260 40 25;260 40 30;260 40 35;260 40 40;260 40 45;260 50 05;260 50 10;260 50 15;260 50 20;260 50 25;260 50 30;260 50 35;
260 50 40;260 60 05;260 60 10;260 60 15;260 60 20;260 60 25;260 60 30;260 60 35;260 70 05;260 70 10;260 70 15;260 70 20;260 70 25;260 80 05;
260 80 10;260 80 15;260 85 05;260 85 10;260 90 05;270 20 10;270 20 15;270 20 20;270 20 25;270 20 29;270 30 10;270 30 15;270 30 20;270 30 25;
270 30 30;270 30 35;270 30 40;270 30 45;270 40 10;270 40 15;270 40 20;270 40 25;270 40 30;270 40 35;270 40 40;270 50 10;270 50 15;270 50 20;
270 50 25;270 50 30;270 50 35;270 50 40;270 60 10;270 60 15;270 60 20;270 60 25;270 60 30;270 60 35;270 70 10;270 70 15;270 70 20;270 70 25;
270 80 10;270 80 15;270 85 05;270 85 10;270 85 15;270 90 05;280 20 05;280 20 10;280 20 15;280 20 20;280 20 25;280 20 30;280 30 05;280 30 10;
280 30 15;280 30 20;280 30 25;280 30 30;280 30 35;280 30 40;280 40 05;280 40 10;280 40 15;280 40 20;280 40 25;280 40 30;280 40 35;280 40 40;
280 40 45;280 50 05;280 50 10;280 50 15;280 50 20;280 50 25;280 50 30;280 50 35;280 50 40;280 60 05;280 60 10;280 60 15;280 60 20;280 60 25;
280 60 30;280 60 35;280 70 05;280 70 10;280 70 15;280 70 20;280 70 25;280 80 05;280 80 10;280 80 15;280 85 05;280 85 10;280 90 05;280 93 05;
290 20 10;290 20 15;290 20 20;290 20 25;290 20 30;290 20 35;290 30 10;290 30 15;290 30 20;290 30 25;290 30 30;290 30 35;290 30 40;290 40 10;
290 40 15;290 40 20;290 40 25;290 40 30;290 40 35;290 40 40;290 40 45;290 50 10;290 50 15;290 50 20;290 50 25;290 50 30;290 50 35;290 50 40;
290 60 10;290 60 15;290 60 20;290 60 25;290 60 30;290 60 35;290 70 10;290 70 15;290 70 20;290 70 25;290 80 10;290 80 15;290 85 05;290 85 10;
290 90 05;290 92 05;290 93 05;300 20 05;300 20 10;300 20 15;300 20 20;300 20 25;300 20 30;300 30 05;300 30 10;300 30 15;300 30 20;300 30 25;
300 30 30;300 30 35;300 30 40;300 40 05;300 40 10;300 40 15;300 40 20;300 40 25;300 40 30;300 40 35;300 40 40;300 40 45;300 50 05;300 50 10;
300 50 15;300 50 20;300 50 25;300 50 30;300 50 35;300 50 40;300 60 05;300 60 10;300 60 15;300 60 20;300 60 25;300 60 30;300 60 35;300 70 05;
300 70 10;300 70 15;300 70 20;300 70 25;300 80 05;300 80 10;300 80 15;300 85 05;300 85 10;300 90 05;3000;3001;3002;3003;
3004;3005;3007;3009;3011;3012;3013;3014;3015;3016;3017;3018;3020;3022;
3027;3031;310 20 10;310 20 15;310 20 20;310 20 25;310 20 30;310 30 10;310 30 15;310 30 20;310 30 25;310 30 30;310 30 35;310 30 40;
310 40 10;310 40 15;310 40 20;310 40 25;310 40 30;310 40 35;310 40 40;310 50 10;310 50 15;310 50 20;310 50 25;310 50 30;310 50 35;310 50 40;
310 60 10;310 60 15;310 60 20;310 60 25;310 60 30;310 60 35;310 70 10;310 70 15;310 70 20;310 70 25;310 80 10;310 80 15;310 85 10;310 90 05;
320 20 05;320 20 10;320 20 15;320 20 20;320 20 25;320 30 05;320 30 10;320 30 15;320 30 20;320 30 25;320 30 30;320 30 35;320 30 37;320 40 05;
320 40 10;320 40 15;320 40 20;320 40 25;320 40 30;320 40 35;320 40 40;320 50 05;320 50 10;320 50 15;320 50 20;320 50 25;320 50 30;320 50 35;
320 50 39;320 50 40;320 60 05;320 60 10;320 60 15;320 60 20;320 60 25;320 60 30;320 60 35;320 70 05;320 70 10;320 70 15;320 70 20;320 70 25;
320 80 05;320 80 10;320 80 15;320 85 05;320 85 10;320 90 05;330 20 10;330 20 15;330 20 20;330 20 25;330 30 10;330 30 15;330 30 20;330 30 25;
330 30 30;330 30 35;330 30 40;330 40 10;330 40 15;330 40 20;330 40 25;330 40 30;330 40 35;330 40 40;330 40 45;330 50 10;330 50 15;330 50 20;
330 50 25;330 50 30;330 50 35;330 50 40;330 60 10;330 60 15;330 60 20;330 60 25;330 60 30;330 60 35;330 60 40;330 70 10;330 70 15;330 70 20;
330 70 25;330 70 30;330 80 10;330 80 15;330 80 20;330 85 05;330 85 10;330 85 15;330 90 05;340 20 05;340 20 10;340 20 15;340 20 20;340 20 25;
340 30 05;340 30 10;340 30 15;340 30 20;340 30 25;340 30 30;340 30 35;340 30 38;340 40 05;340 40 10;340 40 15;340 40 20;340 40 25;340 40 30;
340 40 35;340 40 40;340 40 45;340 50 05;340 50 10;340 50 15;340 50 20;340 50 25;340 50 30;340 50 35;340 50 40;340 50 45;340 60 05;340 60 10;
340 60 15;340 60 20;340 60 25;340 60 30;340 60 35;340 60 40;340 70 05;340 70 10;340 70 15;340 70 20;340 70 25;340 70 30;340 70 35;340 80 05;
340 80 10;340 80 15;340 80 20;340 85 05;340 85 10;340 85 15;340 90 05;340 92 05;340 93 05;350 20 10;350 20 15;350 20 20;350 20 25;350 20 30;
350 30 10;350 30 15;350 30 20;350 30 25;350 30 30;350 30 35;350 30 40;350 40 10;350 40 15;350 40 20;350 40 25;350 40 30;350 40 35;350 40 40;
350 40 45;350 40 50;350 50 10;350 50 15;350 50 20;350 50 25;350 50 30;350 50 35;350 50 40;350 50 45;350 50 50;350 60 10;350 60 15;350 60 20;
350 60 25;350 60 30;350 60 35;350 60 40;350 60 45;350 70 10;350 70 15;350 70 20;350 70 25;350 70 30;350 70 35;350 80 10;350 80 15;350 80 20;
350 85 05;350 85 10;350 85 15;350 90 05;350 93 05;360 20 05;360 20 10;360 20 15;360 30 05;360 30 10;360 30 15;360 30 20;360 30 25;360 30 30;
360 30 35;360 30 40;360 40 05;360 40 10;360 40 15;360 40 20;360 40 25;360 40 30;360 40 35;360 40 40;360 40 45;360 40 50;360 50 05;360 50 10;
360 50 15;360 50 20;360 50 25;360 50 30;360 50 35;360 50 40;360 50 45;360 50 50;360 60 05;360 60 10;360 60 15;360 60 20;360 60 25;360 70 05;
360 70 10;360 70 15;360 80 05;360 80 10;360 80 15;360 85 05;360 85 10;360 90 05;360 92 05;360 93 05;4001;4002;4003;4004;
4005;4006;4007;4008;4009;4010;5000;5001;5002;5003;5004;5005;5007;5008;
5009;5010;5011;5012;5013;5014;5015;5017;5018;5019;5020;5021;5022;5023;
5024;6000;6001;6002;6003;6004;6005;6006;6007;6008;6009;6010;6011;6012;
6013;6014;6015;6016;6017;6018;6019;6020;6021;6022;6024;6025;6026;6027;
6028;6029;6032;6033;6034;7000;7001;7002;7003;7004;7005;7006;7008;7009;
7010;7011;7012;7013;7015;7016;7021;7022;7023;7024;7026;7030;7031;7032;
7033;7034;7035;7036;7037;7038;7039;7040;7042;7043;7044;7045;7046;7047;
8000;8001;8002;8003;8004;8007;8008;8011;8012;8014;8015;8016;8017;8019;
8022;8023;8024;8025;8028;9001;9002;9003;9004;9005;9006;9007;9010;9011;
9016;9017;9018
`.trim().split(/;\s*/));

const AVAILABLE_RAL_COLORS = Object.entries(RAL_ALL_COLORS)
    .filter(
        ([code]) =>
            RAL_PRODUCER_CODES.has(code)
    )
    .map(([code, hex]) => ({
        code,
        hex,
        r: parseInt(hex.slice(1, 3), 16),
        g: parseInt(hex.slice(3, 5), 16),
        b: parseInt(hex.slice(5, 7), 16)
    }));

// ========== Color Utilities ==========
class ColorManager {
    constructor() {
        this.root = document.querySelector(
            '.choose-color.product-color-picker'
        );

        this.hexInput = this.root?.querySelector(
            '.choose-color__selection-hex input'
        );

        this.ralInput = this.root?.querySelector(
            '.choose-color__selection-ral input'
        );

        this.showColorsBtn = this.root?.querySelector(
            '.choose-color__show-colors'
        );

        this.resetBtn = this.root?.querySelector(
            '.choose-color__reset-btn'
        );

        this.colorPreview = this.root?.querySelector(
            '.choose-color__selection-result-heading-value'
        );

        this.colorDisplay = this.root?.querySelector(
            '.choose-color__selection-choosen-color'
        );

        this.pickerContainer = this.root?.querySelector(
            '[data-inline-color-picker]'
        );

        this.isRalOnly = this.root?.dataset.colorMode === 'ral';

        this.currentColor = null;
        this.colorPicker = null;
        this.colorPickerMode = null;
        this.colorPickerVisible = false;
        this.defaultColor = '#77A94F';
        this.defaultRalCode = '9010';
        this.onColorChange = null;
        this.isSyncingPicker = false;

        this.createColorPropertyInput();
        this.init();
    }

    createColorPropertyInput() {
        if (this.isRalOnly && this.ralInput) {
            this.colorPropertyInput = this.ralInput;
            return this.ralInput;
        }

        const productInfo = this.root?.closest('product-info');

        const productForm = productInfo?.querySelector(
            'product-form form'
        );

        if (!productForm) return;

        const existingInput = productForm.querySelector(
            'input[name="properties[Farbe]"]'
        );

        if (existingInput) {
            this.colorPropertyInput = existingInput;
            return existingInput;
        }

        this.colorPropertyInput = document.createElement('input');
        this.colorPropertyInput.type = 'hidden';
        this.colorPropertyInput.name = 'properties[Farbe]';
        this.colorPropertyInput.value = '';

        productForm.appendChild(this.colorPropertyInput);

        return this.colorPropertyInput;
    }

    init() {
        if (!this.root || !this.ralInput) return;

        let inlinePickerReady;

        if (this.isRalOnly) {
            this.updateColor(
                RAL_ALL_COLORS[this.defaultRalCode],
                'ral',
                this.defaultRalCode
            );
            inlinePickerReady = this.initRalPalette();
        } else {
            this.updateColor(this.defaultColor, 'hex');
            inlinePickerReady = this.initInlineColorPicker();
        }

        this.hexInput?.addEventListener('input', (event) => {
            const color = this.normalizeHex(event.target.value);

            if (color) {
                this.updateColor(color, 'hex');
            }
        });

        this.ralInput.addEventListener('input', (event) => {
            const ralCode = this.normalizeRalCode(
                event.target.value
            );

            const colorDatabase = this.isRalOnly
                ? RAL_ALL_COLORS
                : RAL_CLASSIC_COLORS;

            if (this.isRalOnly) {
                this.ralInput.removeAttribute('name');
                this.ralInput.setCustomValidity(
                    this.isRalAvailable(ralCode)
                        ? ''
                        : 'Bitte wähle einen RAL-Ton aus der freigegebenen Herstellerliste.'
                );
            }

            if (
                colorDatabase[ralCode] &&
                (!this.isRalOnly || this.isRalAvailable(ralCode))
            ) {
                this.updateColor(
                    colorDatabase[ralCode],
                    'ral',
                    ralCode
                );
            }
        });

        if (inlinePickerReady) {
            /*
             * Der Picker ist bereits sichtbar.
             * Der alte Öffnen-Button wird nicht mehr benötigt.
             */
            if (this.showColorsBtn) {
                this.showColorsBtn.hidden = true;
            }
        } else {
            /*
             * Fallback, falls iro.js nicht geladen werden konnte.
             */
            this.showColorsBtn?.addEventListener('click', () => {
                this.showNativeColorPicker();
            });
        }

        this.resetBtn?.addEventListener('click', () => {
            this.reset();
        });
    }

    initRalPalette() {
        if (!this.pickerContainer) return false;

        this.pickerContainer.replaceChildren();
        this.pickerContainer.classList.add(
            'choose-color__inline-picker--ral'
        );

        this.ralPaletteGrid = document.createElement('div');
        this.ralPaletteGrid.className = 'choose-color__ral-grid';
        this.ralPaletteGrid.setAttribute('role', 'listbox');
        this.ralPaletteGrid.setAttribute(
            'aria-label',
            'Verf\u00fcgbare RAL-Farben'
        );

        this.ralPaletteEmpty = document.createElement('div');
        this.ralPaletteEmpty.className = 'choose-color__ral-empty';
        this.ralPaletteEmpty.textContent =
            'Keine passende RAL-Farbe gefunden.';
        this.ralPaletteEmpty.hidden = true;

        const hueControl = document.createElement('label');
        hueControl.className = 'choose-color__ral-hue-control';

        const hueLabel = document.createElement('span');
        hueLabel.className = 'visually-hidden';
        hueLabel.textContent = 'Farbton';

        this.ralHueInput = document.createElement('input');
        this.ralHueInput.className = 'choose-color__ral-hue';
        this.ralHueInput.type = 'range';
        this.ralHueInput.min = '0';
        this.ralHueInput.max = '360';
        this.ralHueInput.step = '5';
        this.ralHueInput.value = '120';
        this.ralHueInput.setAttribute(
            'aria-label',
            'RAL-Farbton ausw\u00e4hlen'
        );

        hueControl.append(hueLabel, this.ralHueInput);

        this.pickerContainer.append(
            this.ralPaletteGrid,
            this.ralPaletteEmpty,
            hueControl
        );

        this.ralPaletteHue = 120;
        this.ralPaletteColors = AVAILABLE_RAL_COLORS.map((ral) => ({
            ...ral,
            ...this.getRalMetrics(ral)
        }));

        this.ralHueInput.addEventListener('input', (event) => {
            this.ralPaletteHue = Number(event.target.value);
            this.renderRalPalette();
        });

        const getRalSwatch = (event) => {
            const swatch = event.target.closest('[data-ral-code]');

            if (!swatch) return null;

            const ralCode = swatch.dataset.ralCode;
            const color = RAL_ALL_COLORS[ralCode];

            if (!color || !this.isRalAvailable(ralCode)) {
                return null;
            }

            return { ralCode, color };
        };

        const selectRalSwatch = (event) => {
            const ral = getRalSwatch(event);

            if (!ral) return;

            this.updateColor(
                ral.color,
                'ral',
                ral.ralCode,
                false
            );
        };

        this.ralPaletteGrid.addEventListener('click', selectRalSwatch);

        this.renderRalPalette();
        return true;
    }

    renderRalPalette() {
        if (!this.ralPaletteGrid) return;

        const colors = this.buildRalField(this.ralPaletteHue);
        const fragment = document.createDocumentFragment();
        this.ralPaletteSwatches = new Map();
        this.selectedRalSwatch = null;

        for (const ral of colors) {
            const swatch = document.createElement('button');
            swatch.type = 'button';
            swatch.className = 'choose-color__ral-swatch';
            swatch.dataset.ralCode = ral.code;
            swatch.style.setProperty('--ral-color', ral.hex);
            swatch.setAttribute('role', 'option');
            swatch.setAttribute('aria-label', `RAL ${ral.code}`);
            swatch.title = `RAL ${ral.code}`;

            const isSelected = ral.code === this.currentRalCode;
            swatch.classList.toggle(
                'choose-color__ral-swatch--selected',
                isSelected
            );
            swatch.setAttribute('aria-selected', String(isSelected));
            this.ralPaletteSwatches.set(ral.code, swatch);

            if (isSelected) {
                this.selectedRalSwatch = swatch;
            }

            fragment.appendChild(swatch);
        }

        this.ralPaletteGrid.replaceChildren(fragment);
        this.ralPaletteEmpty.hidden = colors.length !== 0;
        this.ralPaletteGrid.hidden = colors.length === 0;
    }

    buildRalField(hue) {
        const columns = 12;
        const rows = 7;
        const cells = columns * rows;
        const nearbyColors = this.ralPaletteColors.filter(
            (ral) =>
                ral.saturation < 0.14 ||
                this.getHueDistance(ral.hue, hue) <= 40
        );
        const colors =
            nearbyColors.length >= cells
                ? nearbyColors
                : this.ralPaletteColors;
        const usedCodes = new Set();
        const field = [];

        for (let row = 0; row < rows; row += 1) {
            const targetLightness =
                0.94 - (row / (rows - 1)) * 0.82;

            for (let column = 0; column < columns; column += 1) {
                const targetSaturation = column / (columns - 1);
                let closestColor = null;
                let closestDistance = Infinity;

                for (const ral of colors) {
                    if (usedCodes.has(ral.code)) continue;

                    const hueDistance =
                        targetSaturation < 0.08
                            ? ral.saturation * 2
                            : (this.getHueDistance(ral.hue, hue) / 180) *
                              (0.7 + targetSaturation);
                    const saturationDistance =
                        Math.abs(ral.saturation - targetSaturation) * 1.7;
                    const lightnessDistance =
                        Math.abs(ral.lightness - targetLightness) * 2.8;
                    const distance =
                        hueDistance +
                        saturationDistance +
                        lightnessDistance;

                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestColor = ral;
                    }
                }

                if (closestColor) {
                    usedCodes.add(closestColor.code);
                    field.push(closestColor);
                }
            }
        }

        return field;
    }

    getHueDistance(firstHue, secondHue) {
        const difference = Math.abs(firstHue - secondHue) % 360;
        return Math.min(difference, 360 - difference);
    }

    getRalMetrics(ral) {
        const red = ral.r / 255;
        const green = ral.g / 255;
        const blue = ral.b / 255;
        const maximum = Math.max(red, green, blue);
        const minimum = Math.min(red, green, blue);
        const delta = maximum - minimum;
        const lightness = (maximum + minimum) / 2;
        let hue = 0;

        if (delta !== 0) {
            if (maximum === red) {
                hue = 60 * (((green - blue) / delta) % 6);
            } else if (maximum === green) {
                hue = 60 * ((blue - red) / delta + 2);
            } else {
                hue = 60 * ((red - green) / delta + 4);
            }
        }

        if (hue < 0) hue += 360;

        const saturation =
            delta === 0
                ? 0
                : delta / (1 - Math.abs(2 * lightness - 1));

        let family = 'red';

        if (saturation < 0.12) family = 'neutral';
        else if (hue < 15 || hue >= 345) family = 'red';
        else if (hue < 45) family = 'orange';
        else if (hue < 70) family = 'yellow';
        else if (hue < 165) family = 'green';
        else if (hue < 195) family = 'turquoise';
        else if (hue < 255) family = 'blue';
        else if (hue < 315) family = 'violet';
        else family = 'pink';

        return { family, hue, lightness, saturation };
    }

    syncRalPaletteSelection(ralCode) {
        this.currentRalCode = ralCode;

        if (this.selectedRalSwatch) {
            this.selectedRalSwatch.classList.remove(
                'choose-color__ral-swatch--selected'
            );
            this.selectedRalSwatch.setAttribute(
                'aria-selected',
                'false'
            );
        }

        this.selectedRalSwatch =
            this.ralPaletteSwatches?.get(ralCode) || null;

        if (this.selectedRalSwatch) {
            this.selectedRalSwatch.classList.add(
                'choose-color__ral-swatch--selected'
            );
            this.selectedRalSwatch.setAttribute(
                'aria-selected',
                'true'
            );
        }
    }

    initInlineColorPicker() {
        if (!this.pickerContainer) {
            return false;
        }

        if (typeof window.iro === 'undefined') {
            return false;
        }

        const availableWidth =
            this.pickerContainer.clientWidth ||
            this.root?.clientWidth ||
            320;

        const pickerWidth = Math.min(
            420,
            Math.max(220, availableWidth - 2)
        );

        const boxHeight = Math.min(
            210,
            Math.round(pickerWidth * 0.55)
        );

        this.colorPicker = new window.iro.ColorPicker(
    this.pickerContainer,
    {
        width: pickerWidth,
        color: this.currentColor || this.defaultColor,
        margin: 14,
        padding: 6,
        borderWidth: 1,
        borderColor: '#D8E0E2',
        handleRadius: 9,
        layout: [
            {
                component: window.iro.ui.Box,
                options: {
                    boxHeight: boxHeight
                }
            },
            {
                component: window.iro.ui.Slider,
                options: {
                    sliderType: 'hue'
                }
            }
        ]
    }
);

        this.colorPickerMode = 'inline';

        /*
         * Wird nur bei direkter Bedienung mit Maus oder Touch ausgelöst.
         */
        this.colorPicker.on('input:change', (color) => {
            if (this.isSyncingPicker) return;

            this.updateColor(
                color.hexString.toUpperCase(),
                'picker'
            );
        });

        return true;
    }

    normalizeHex(value) {
        if (typeof value !== 'string') return null;

        let hex = value.trim();

        if (!hex.startsWith('#')) {
            hex = `#${hex}`;
        }

        if (/^#[0-9A-Fa-f]{3}$/.test(hex)) {
            hex = `#${hex
                .slice(1)
                .split('')
                .map((character) => character + character)
                .join('')}`;
        }

        if (!/^#[0-9A-Fa-f]{6}$/.test(hex)) {
            return null;
        }

        return hex.toUpperCase();
    }

    isValidHex(value) {
        return this.normalizeHex(value) !== null;
    }

    normalizeRalCode(value) {
        if (typeof value !== 'string') return '';

        let ralCode = value
            .trim()
            .toUpperCase()
            .replace(/^RAL\s*/, '')
            .replace(/\s+/g, ' ');

        if (/^\d{7}$/.test(ralCode)) {
            ralCode = `${ralCode.slice(0, 3)} ${ralCode.slice(
                3,
                5
            )} ${ralCode.slice(5)}`;
        }

        const designCode = ralCode.match(/^(\d{1,3}) (\d{2}) (\d{2})$/);
        if (designCode) {
            ralCode = `${designCode[1].padStart(3, '0')} ${designCode[2]} ${designCode[3]}`;
        } else if (/^\d{2} 00$/.test(ralCode)) {
            // The manufacturer also lists neutral Design shades without the 000 hue.
            ralCode = `000 ${ralCode}`;
        }

        if (/^\d{3}\s*-\s*[1-6M]$/.test(ralCode)) {
            ralCode = ralCode.replace(/\s/g, '');
        }

        return ralCode;
    }

    isRalAvailable(ralCode) {
        return (
            Boolean(RAL_ALL_COLORS[ralCode]) &&
            RAL_PRODUCER_CODES.has(ralCode)
        );
    }

    hexToRal(hex) {
        const normalizedHex = this.normalizeHex(hex);

        if (!normalizedHex) return null;

        let closestRal = null;
        let minDistance = Infinity;

        const hexRgb = this.hexToRgb(normalizedHex);

        if (!hexRgb) return null;

        for (const [ral, ralHex] of Object.entries(
            RAL_CLASSIC_COLORS
        )) {
            const ralRgb = this.hexToRgb(ralHex);

            if (!ralRgb) continue;

            const distance = this.colorDistance(
                hexRgb,
                ralRgb
            );

            if (distance < minDistance) {
                minDistance = distance;
                closestRal = ral;
            }
        }

        return closestRal;
    }

    hexToRgb(hex) {
        const normalizedHex = this.normalizeHex(hex);

        if (!normalizedHex) return null;

        const result =
            /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
                normalizedHex
            );

        if (!result) return null;

        return {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        };
    }

    colorDistance(rgb1, rgb2) {
        if (!rgb1 || !rgb2) return Infinity;

        return Math.sqrt(
            Math.pow(rgb1.r - rgb2.r, 2) +
            Math.pow(rgb1.g - rgb2.g, 2) +
            Math.pow(rgb1.b - rgb2.b, 2)
        );
    }

    updateColor(
        color,
        source = 'hex',
        ralCode = null,
        syncPicker = true
    ) {
        if (this.isRalOnly && !this.isRalAvailable(ralCode)) return;
        const normalizedColor = this.normalizeHex(color);

        if (!normalizedColor) return;

        this.currentColor = normalizedColor;

        let displayRal = ralCode;

        if (this.colorDisplay) {
            this.colorDisplay.style.backgroundColor =
                normalizedColor;
        }

        if (source === 'ral') {
            if (this.isRalOnly) this.ralInput?.setCustomValidity('');
            if (
                this.ralInput &&
                this.ralInput.value !== `RAL ${ralCode}`
            ) {
                this.ralInput.value = `RAL ${ralCode}`;
            }

            if (this.hexInput) {
                this.hexInput.value = normalizedColor;
            }

            displayRal = ralCode;
            this.syncRalPaletteSelection(ralCode);
        } else {
            if (
                this.hexInput &&
                this.hexInput.value !== normalizedColor
            ) {
                this.hexInput.value = normalizedColor;
            }

            const closestRal = this.hexToRal(
                normalizedColor
            );

            if (closestRal && this.ralInput) {
                this.ralInput.value = `RAL ${closestRal}`;
                displayRal = closestRal;
            }
        }

        if (this.colorPreview) {
            this.colorPreview.textContent = displayRal
                ? `RAL ${displayRal}`
                : normalizedColor;
        }

        /*
         * Manuelle HEX- oder RAL-Eingaben zurück
         * an den sichtbaren Inline Picker übertragen.
         */
        if (
            this.colorPicker &&
            this.colorPickerMode === 'inline' &&
            syncPicker &&
            this.colorPicker.color.hexString.toUpperCase() !==
                normalizedColor
        ) {
            this.isSyncingPicker = true;
            this.colorPicker.color.hexString =
                normalizedColor;
            this.isSyncingPicker = false;
        }

        if (
            this.colorPicker &&
            this.colorPickerMode === 'native'
        ) {
            this.colorPicker.value = normalizedColor;
        }

        const colorPropertyInput =
            this.createColorPropertyInput();

        if (colorPropertyInput) {
            const propertyValue = this.isRalOnly
                ? displayRal
                    ? `RAL ${displayRal}`
                    : ''
                : displayRal
                  ? `RAL ${displayRal} (${normalizedColor})`
                  : normalizedColor;

            colorPropertyInput.value = propertyValue;
            colorPropertyInput.defaultValue = propertyValue;
            colorPropertyInput.name = 'properties[Farbe]';
            colorPropertyInput.setAttribute(
                'value',
                propertyValue
            );
        }

        if (typeof this.onColorChange === 'function') {
            this.onColorChange(normalizedColor);
        }
    }

    /*
     * Nur als Fallback, falls iro.js nicht verfügbar ist.
     */
    showNativeColorPicker() {
        if (!this.colorPicker) {
            this.colorPicker = document.createElement('input');
            this.colorPicker.type = 'color';
            this.colorPicker.className =
                'choose-color__picker';

            this.colorPicker.value =
                this.currentColor || this.defaultColor;

            this.showColorsBtn.parentNode.insertBefore(
                this.colorPicker,
                this.showColorsBtn.nextSibling
            );

            this.colorPickerMode = 'native';

            this.colorPicker.addEventListener(
                'input',
                (event) => {
                    this.updateColor(
                        event.target.value,
                        'picker'
                    );
                }
            );

            this.colorPicker.addEventListener(
                'blur',
                () => {
                    this.hideNativeColorPicker();
                }
            );

            this.colorPicker.addEventListener(
                'change',
                () => {
                    this.hideNativeColorPicker();
                }
            );
        }

        this.colorPicker.style.display = 'block';
        this.colorPickerVisible = true;

        try {
            if (
                typeof this.colorPicker.showPicker ===
                'function'
            ) {
                this.colorPicker.showPicker();
            } else {
                this.colorPicker.click();
            }
        } catch (error) {
            this.colorPicker.click();
        }
    }

    hideNativeColorPicker() {
        if (
            this.colorPicker &&
            this.colorPickerMode === 'native'
        ) {
            this.colorPicker.style.display = 'none';
            this.colorPickerVisible = false;
        }
    }

    reset() {
        if (this.isRalOnly) {
            this.updateColor(
                RAL_ALL_COLORS[this.defaultRalCode],
                'ral',
                this.defaultRalCode
            );
        } else {
            this.updateColor(this.defaultColor, 'hex');
        }

        this.hideNativeColorPicker();
    }
}

// ========== Preview Manager ==========
class PreviewManager {
    constructor(colorManager) {
        this.colorManager = colorManager;
        this.previewTitles = document.querySelectorAll('.choose-color__preview-title');
        this.previewImages = document.querySelectorAll('.choose-color__preview-image');

        this.init();
    }

    init() {
        if (this.previewImages.length === 0) return;

        // Set first preview as active by default
        this.setActivePreview(0);

        // Add click handlers to preview titles (if any exist)
        this.previewTitles.forEach((title, index) => {
            title.addEventListener('click', () => {
                this.setActivePreview(index);
            });
        });

        // Always subscribe to color changes so masks update
        if (this.colorManager) {
            this.colorManager.onColorChange = (color) => {
                this.updatePreviewColor(color);
            };
            if (this.colorManager.currentColor) {
                this.updatePreviewColor(this.colorManager.currentColor);
            }
        }
    }

    setActivePreview(index) {
        this.previewTitles.forEach(title => {
            title.classList.remove('choose-color__preview-title--active');
        });

        this.previewImages.forEach(image => {
            image.style.display = 'none';
        });

        if (this.previewTitles[index]) {
            this.previewTitles[index].classList.add('choose-color__preview-title--active');
        }

        if (this.previewImages[index]) {
            this.previewImages[index].style.display = 'block';
        }

        // Re-apply current color to newly active preview
        if (this.colorManager && this.colorManager.currentColor) {
            this.updatePreviewColor(this.colorManager.currentColor);
        }
    }

    // Apply selected color to all paint-mask layers
    updatePreviewColor(color) {
        document.querySelectorAll('.choose-color__preview-mask').forEach(mask => {
            mask.style.backgroundColor = color;
        });
    }
}

// ========== Initialize ==========
document.addEventListener('DOMContentLoaded', () => {
    // Price calculation
    const element = document.querySelector('.choose-color__container product-info');
    if (element) {
        insertFinalPrice(element);

        element.addEventListener('change', (e) => {
            if (e.target.matches('input[type="radio"], quantity-input input')) {
                if (e.target.matches('input[type="radio"]')) {
                    insertFinalPrice(element, 1);
                } else {
                    insertFinalPrice(element, null);
                }
            }
        });
    }

    // Color manager
    const colorManager = new ColorManager();

    // Preview manager
    new PreviewManager(colorManager);
});
